/**
 * File generated by js-routes 2.2.8
 * Based on Rails 8.1.3.1 routes of Gumroad::Application
 */
// eslint-disable-next-line
const __jsr = (
// eslint-disable-next-line
() => {
    const hasProp = (value, key) => Object.prototype.hasOwnProperty.call(value, key);
    let NodeTypes;
    (function (NodeTypes) {
        NodeTypes[NodeTypes["GROUP"] = 1] = "GROUP";
        NodeTypes[NodeTypes["CAT"] = 2] = "CAT";
        NodeTypes[NodeTypes["SYMBOL"] = 3] = "SYMBOL";
        NodeTypes[NodeTypes["OR"] = 4] = "OR";
        NodeTypes[NodeTypes["STAR"] = 5] = "STAR";
        NodeTypes[NodeTypes["LITERAL"] = 6] = "LITERAL";
        NodeTypes[NodeTypes["SLASH"] = 7] = "SLASH";
        NodeTypes[NodeTypes["DOT"] = 8] = "DOT";
    })(NodeTypes || (NodeTypes = {}));
    const isBrowser = typeof window !== "undefined";
    const UnescapedSpecials = "-._~!$&'()*+,;=:@"
        .split("")
        .map((s) => s.charCodeAt(0));
    const UnescapedRanges = [
        ["a", "z"],
        ["A", "Z"],
        ["0", "9"],
    ].map((range) => range.map((s) => s.charCodeAt(0)));
    const ModuleReferences = {
        CJS: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                module.exports = routes;
            },
            isSupported() {
                return typeof module === "object";
            },
        },
        AMD: {
            define(routes) {
                // eslint-disable-next-line @typescript-eslint/no-non-null-assertion
                define([], function () {
                    return routes;
                });
            },
            isSupported() {
                return typeof define === "function" && !!define.amd;
            },
        },
        UMD: {
            define(routes) {
                if (ModuleReferences.AMD.isSupported()) {
                    ModuleReferences.AMD.define(routes);
                }
                else {
                    if (ModuleReferences.CJS.isSupported()) {
                        try {
                            ModuleReferences.CJS.define(routes);
                        }
                        catch (error) {
                            if (error.name !== "TypeError")
                                throw error;
                        }
                    }
                }
            },
            isSupported() {
                return (ModuleReferences.AMD.isSupported() ||
                    ModuleReferences.CJS.isSupported());
            },
        },
        ESM: {
            define() {
                // Module can only be defined using ruby code generation
            },
            isSupported() {
                // Its impossible to check if "export" keyword is supported
                return true;
            },
        },
        NIL: {
            define() {
                // Defined using const __jsr = 
            },
            isSupported() {
                return true;
            },
        },
        DTS: {
            // Acts the same as ESM
            define(routes) {
                ModuleReferences.ESM.define(routes);
            },
            isSupported() {
                return ModuleReferences.ESM.isSupported();
            },
        },
    };
    class ParametersMissing extends Error {
        constructor(...keys) {
            super(`Route missing required keys: ${keys.join(", ")}`);
            this.keys = keys;
            Object.setPrototypeOf(this, Object.getPrototypeOf(this));
            this.name = ParametersMissing.name;
        }
    }
    const ReservedOptions = [
        "anchor",
        "trailing_slash",
        "subdomain",
        "host",
        "port",
        "protocol",
    ];
    class UtilsClass {
        constructor() {
            this.configuration = {
                prefix: "",
                default_url_options: {"protocol":"https","host":"gumroad.com"},
                special_options_key: "_options",
                serializer: null || this.default_serializer.bind(this),
            };
        }
        default_serializer(value, prefix) {
            if (this.is_nullable(value)) {
                return "";
            }
            if (!prefix && !this.is_object(value)) {
                throw new Error("Url parameters should be a javascript hash");
            }
            prefix = prefix || "";
            const result = [];
            if (this.is_array(value)) {
                for (const element of value) {
                    result.push(this.default_serializer(element, prefix + "[]"));
                }
            }
            else if (this.is_object(value)) {
                for (let key in value) {
                    if (!hasProp(value, key))
                        continue;
                    let prop = value[key];
                    if (this.is_nullable(prop) && prefix) {
                        prop = "";
                    }
                    if (this.is_not_nullable(prop)) {
                        if (prefix) {
                            key = prefix + "[" + key + "]";
                        }
                        result.push(this.default_serializer(prop, key));
                    }
                }
            }
            else {
                if (this.is_not_nullable(value)) {
                    result.push(encodeURIComponent(prefix) + "=" + encodeURIComponent("" + value));
                }
            }
            return result.join("&");
        }
        serialize(object) {
            return this.configuration.serializer(object);
        }
        extract_options(number_of_params, args) {
            const last_el = args[args.length - 1];
            if ((args.length > number_of_params && last_el === 0) ||
                (this.is_object(last_el) &&
                    !this.looks_like_serialized_model(last_el))) {
                if (this.is_object(last_el)) {
                    delete last_el[this.configuration.special_options_key];
                }
                return {
                    args: args.slice(0, args.length - 1),
                    options: last_el,
                };
            }
            else {
                return { args, options: {} };
            }
        }
        looks_like_serialized_model(object) {
            return (this.is_object(object) &&
                !(this.configuration.special_options_key in object) &&
                ("id" in object || "to_param" in object || "toParam" in object));
        }
        path_identifier(object) {
            const result = this.unwrap_path_identifier(object);
            return this.is_nullable(result) ||
                (false &&
                    result === false)
                ? ""
                : "" + result;
        }
        unwrap_path_identifier(object) {
            let result = object;
            if (!this.is_object(object)) {
                return object;
            }
            if ("to_param" in object) {
                result = object.to_param;
            }
            else if ("toParam" in object) {
                result = object.toParam;
            }
            else if ("id" in object) {
                result = object.id;
            }
            else {
                result = object;
            }
            return this.is_callable(result) ? result.call(object) : result;
        }
        partition_parameters(parts, required_params, default_options, call_arguments) {
            // eslint-disable-next-line prefer-const
            let { args, options } = this.extract_options(parts.length, call_arguments);
            if (args.length > parts.length) {
                throw new Error("Too many parameters provided for path");
            }
            let use_all_parts = args.length > required_params.length;
            const parts_options = {
                ...this.configuration.default_url_options,
            };
            for (const key in options) {
                const value = options[key];
                if (!hasProp(options, key))
                    continue;
                use_all_parts = true;
                if (parts.includes(key)) {
                    parts_options[key] = value;
                }
            }
            options = {
                ...this.configuration.default_url_options,
                ...default_options,
                ...options,
            };
            const keyword_parameters = {};
            let query_parameters = {};
            for (const key in options) {
                if (!hasProp(options, key))
                    continue;
                const value = options[key];
                if (key === "params") {
                    if (this.is_object(value)) {
                        query_parameters = {
                            ...query_parameters,
                            ...value,
                        };
                    }
                    else {
                        throw new Error("params value should always be an object");
                    }
                }
                else if (this.is_reserved_option(key)) {
                    keyword_parameters[key] = value;
                }
                else {
                    if (!this.is_nullable(value) &&
                        (value !== default_options[key] || required_params.includes(key))) {
                        query_parameters[key] = value;
                    }
                }
            }
            const route_parts = use_all_parts ? parts : required_params;
            let i = 0;
            for (const part of route_parts) {
                if (i < args.length) {
                    const value = args[i];
                    if (!hasProp(parts_options, part)) {
                        query_parameters[part] = value;
                        ++i;
                    }
                }
            }
            return { keyword_parameters, query_parameters };
        }
        build_route(parts, required_params, default_options, route, absolute, args) {
            const { keyword_parameters, query_parameters } = this.partition_parameters(parts, required_params, default_options, args);
            const missing_params = required_params.filter((param) => !hasProp(query_parameters, param) ||
                this.is_nullable(query_parameters[param]));
            if (missing_params.length) {
                throw new ParametersMissing(...missing_params);
            }
            let result = this.get_prefix() + this.visit(route, query_parameters);
            if (keyword_parameters.trailing_slash) {
                result = result.replace(/(.*?)[/]?$/, "$1/");
            }
            const url_params = this.serialize(query_parameters);
            if (url_params.length) {
                result += "?" + url_params;
            }
            result += keyword_parameters.anchor
                ? "#" + keyword_parameters.anchor
                : "";
            if (absolute) {
                result = this.route_url(keyword_parameters) + result;
            }
            return result;
        }
        visit(route, parameters, optional = false) {
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return this.visit(route[1], parameters, true);
                case NodeTypes.CAT:
                    return this.visit_cat(route, parameters, optional);
                case NodeTypes.SYMBOL:
                    return this.visit_symbol(route, parameters, optional);
                case NodeTypes.STAR:
                    return this.visit_globbing(route[1], parameters, true);
                case NodeTypes.LITERAL:
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        is_not_nullable(object) {
            return !this.is_nullable(object);
        }
        is_nullable(object) {
            return object === undefined || object === null;
        }
        visit_cat(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, left, right], parameters, optional) {
            const left_part = this.visit(left, parameters, optional);
            let right_part = this.visit(right, parameters, optional);
            if (optional &&
                ((this.is_optional_node(left[0]) && !left_part) ||
                    (this.is_optional_node(right[0]) && !right_part))) {
                return "";
            }
            // if left_part ends on '/' and right_part starts on '/'
            if (left_part[left_part.length - 1] === "/" && right_part[0] === "/") {
                // strip slash from right_part
                // to prevent double slash
                right_part = right_part.substring(1);
            }
            return left_part + right_part;
        }
        visit_symbol(
        // eslint-disable-next-line @typescript-eslint/no-unused-vars
        [_type, key], parameters, optional) {
            const value = this.path_identifier(parameters[key]);
            delete parameters[key];
            if (value.length) {
                return this.encode_segment(value);
            }
            if (optional) {
                return "";
            }
            else {
                throw new ParametersMissing(key);
            }
        }
        encode_segment(segment) {
            if (segment.match(/^[a-zA-Z0-9-]$/)) {
                // Performance optimization for 99% of cases
                return segment;
            }
            return (segment.match(/./gu) || [])
                .map((ch) => {
                const code = ch.charCodeAt(0);
                if (UnescapedRanges.find((range) => code >= range[0] && code <= range[1]) ||
                    UnescapedSpecials.includes(code)) {
                    return ch;
                }
                else {
                    return encodeURIComponent(ch);
                }
            })
                .join("");
        }
        is_optional_node(node) {
            return [NodeTypes.STAR, NodeTypes.SYMBOL, NodeTypes.CAT].includes(node);
        }
        build_path_spec(route, wildcard = false) {
            let key;
            switch (route[0]) {
                case NodeTypes.GROUP:
                    return `(${this.build_path_spec(route[1])})`;
                case NodeTypes.CAT:
                    return (this.build_path_spec(route[1]) + this.build_path_spec(route[2]));
                case NodeTypes.STAR:
                    return this.build_path_spec(route[1], true);
                case NodeTypes.SYMBOL:
                    key = route[1];
                    if (wildcard) {
                        return (key.startsWith("*") ? "" : "*") + key;
                    }
                    else {
                        return ":" + key;
                    }
                    break;
                case NodeTypes.SLASH:
                case NodeTypes.DOT:
                case NodeTypes.LITERAL:
                    return route[1];
                default:
                    throw new Error("Unknown Rails node type");
            }
        }
        visit_globbing(route, parameters, optional) {
            const key = route[1];
            let value = parameters[key];
            delete parameters[key];
            if (this.is_nullable(value)) {
                return this.visit(route, parameters, optional);
            }
            if (this.is_array(value)) {
                value = value.join("/");
            }
            const result = this.path_identifier(value);
            return false
                ? result
                : encodeURI(result);
        }
        get_prefix() {
            const prefix = this.configuration.prefix;
            return prefix.match("/$")
                ? prefix.substring(0, prefix.length - 1)
                : prefix;
        }
        route(parts_table, route_spec, absolute = false) {
            const required_params = [];
            const parts = [];
            const default_options = {};
            for (const [part, { r: required, d: value }] of Object.entries(parts_table)) {
                parts.push(part);
                if (required) {
                    required_params.push(part);
                }
                if (this.is_not_nullable(value)) {
                    default_options[part] = value;
                }
            }
            const result = (...args) => {
                return this.build_route(parts, required_params, default_options, route_spec, absolute, args);
            };
            result.requiredParams = () => required_params;
            result.toString = () => {
                return this.build_path_spec(route_spec);
            };
            return result;
        }
        route_url(route_defaults) {
            const hostname = route_defaults.host || this.current_host();
            if (!hostname) {
                return "";
            }
            const subdomain = route_defaults.subdomain
                ? route_defaults.subdomain + "."
                : "";
            const protocol = route_defaults.protocol || this.current_protocol();
            let port = route_defaults.port ||
                (!route_defaults.host ? this.current_port() : undefined);
            port = port ? ":" + port : "";
            return protocol + "://" + subdomain + hostname + port;
        }
        current_host() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.hostname)) || "";
        }
        current_protocol() {
            var _a, _b;
            return ((isBrowser && ((_b = (_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.protocol) === null || _b === void 0 ? void 0 : _b.replace(/:$/, ""))) || "http");
        }
        current_port() {
            var _a;
            return (isBrowser && ((_a = window === null || window === void 0 ? void 0 : window.location) === null || _a === void 0 ? void 0 : _a.port)) || "";
        }
        is_object(value) {
            return (typeof value === "object" &&
                Object.prototype.toString.call(value) === "[object Object]");
        }
        is_array(object) {
            return object instanceof Array;
        }
        is_callable(object) {
            return typeof object === "function" && !!object.call;
        }
        is_reserved_option(key) {
            return ReservedOptions.includes(key);
        }
        configure(new_config) {
            this.configuration = { ...this.configuration, ...new_config };
            return this.configuration;
        }
        config() {
            return { ...this.configuration };
        }
        is_module_supported(name) {
            return ModuleReferences[name].isSupported();
        }
        ensure_module_supported(name) {
            if (!this.is_module_supported(name)) {
                throw new Error(`${name} is not supported by runtime`);
            }
        }
        define_module(name, module) {
            this.ensure_module_supported(name);
            ModuleReferences[name].define(module);
        }
    }
    const Utils = new UtilsClass();
    // We want this helper name to be short
    const __jsr = {
        r(parts_table, route_spec, absolute) {
            return Utils.route(parts_table, route_spec, absolute);
        },
    };
    const result = {
        ...__jsr,
        configure: (config) => {
            return Utils.configure(config);
        },
        config: () => {
            return Utils.config();
        },
        serialize: (object) => {
            return Utils.serialize(object);
        },
        ...{},
    };
    Utils.define_module("ESM", result);
    return result;
})();
export const configure = __jsr.configure;

export const config = __jsr.config;

export const serialize = __jsr.serialize;

/**
 * Generates rails route to
 * /CHARGE(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const CHARGE_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"CHARGE"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /CHARGE(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const CHARGE_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"CHARGE"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /_/test/outgoing_traffic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const __test_outgoing_traffic_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"_"],[2,[7,"/"],[2,[6,"test"],[2,[7,"/"],[2,[6,"outgoing_traffic"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /_/test/outgoing_traffic(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const __test_outgoing_traffic_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"_"],[2,[7,"/"],[2,[6,"test"],[2,[7,"/"],[2,[6,"outgoing_traffic"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /about(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const about_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"about"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /about(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const about_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"about"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /collaborators/incomings/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_collaborators_incoming_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"incomings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /collaborators/incomings/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_collaborators_incoming_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"incomings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/team/invitations/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_settings_team_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team/invitations/:id/accept(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const accept_settings_team_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"accept"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/google_calendar/account_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_info_integrations_google_calendar_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google_calendar"],[2,[7,"/"],[2,[6,"account_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/google_calendar/account_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_info_integrations_google_calendar_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google_calendar"],[2,[7,"/"],[2,[6,"account_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/zoom/account_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_info_integrations_zoom_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zoom"],[2,[7,"/"],[2,[6,"account_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/zoom/account_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const account_info_integrations_zoom_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zoom"],[2,[7,"/"],[2,[6,"account_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /.well-known/acme-challenge/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acme_challenge_url = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"acme-challenge"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /.well-known/acme-challenge/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const acme_challenge_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[8,"."],[2,[6,"well-known"],[2,[7,"/"],[2,[6,"acme-challenge"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/add_credit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_credit_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"add_credit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/add_credit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_credit_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"add_credit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /add_purchase_to_library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_purchase_to_library_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"add_purchase_to_library"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /add_purchase_to_library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const add_purchase_to_library_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"add_purchase_to_library"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /admin/features
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_flipper_ui_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"features"]]]], true);

/**
 * Generates rails route to
 * /admin/features
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_flipper_ui_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"features"]]]]);

/**
 * Generates rails route to
 * /admin/impersonate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_impersonate_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/impersonate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_impersonate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"impersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/redirect_to_stripe_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_redirect_to_stripe_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"redirect_to_stripe_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/redirect_to_stripe_dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_redirect_to_stripe_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"redirect_to_stripe_dashboard"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /admin/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sidekiq_web_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"sidekiq"]]]], true);

/**
 * Generates rails route to
 * /admin/sidekiq
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_sidekiq_web_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[6,"sidekiq"]]]]);

/**
 * Generates rails route to
 * /admin/unimpersonate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_unimpersonate_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unimpersonate"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /admin/unimpersonate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const admin_unimpersonate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"unimpersonate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /affiliates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /a/:affiliate_id/:unique_permalink(.:format)
 * @param {any} affiliate_id
 * @param {any} unique_permalink
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_product_url = /*#__PURE__*/ __jsr.r({"affiliate_id":{"r":true},"unique_permalink":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"affiliate_id"],[2,[7,"/"],[2,[3,"unique_permalink"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /a/:affiliate_id/:unique_permalink(.:format)
 * @param {any} affiliate_id
 * @param {any} unique_permalink
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_product_path = /*#__PURE__*/ __jsr.r({"affiliate_id":{"r":true},"unique_permalink":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"affiliate_id"],[2,[7,"/"],[2,[3,"unique_permalink"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /a/:affiliate_id(.:format)
 * @param {any} affiliate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_redirect_url = /*#__PURE__*/ __jsr.r({"affiliate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"affiliate_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /a/:affiliate_id(.:format)
 * @param {any} affiliate_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_redirect_path = /*#__PURE__*/ __jsr.r({"affiliate_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"a"],[2,[7,"/"],[2,[3,"affiliate_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliate_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_request_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /affiliate_requests/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliate_requests/onboarding_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_requests_onboarding_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[6,"onboarding_form"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /affiliate_requests/onboarding_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliate_requests_onboarding_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[6,"onboarding_form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /affiliates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/affiliates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliates_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"affiliates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/affiliates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const affiliates_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"affiliates"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /agent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agent_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agent"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /agent(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const agent_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"agent"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /analytics/data/by_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_data_by_date_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"by_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /analytics/data/by_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_data_by_date_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"by_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analytics/data/by_referral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_data_by_referral_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"by_referral"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /analytics/data/by_referral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_data_by_referral_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"by_referral"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /analytics/data/by_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_data_by_state_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"by_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /analytics/data/by_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const analytics_data_by_state_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"data"],[2,[7,"/"],[2,[6,"by_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /api(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const api_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"api"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /affiliate_requests/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_affiliate_request_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /affiliate_requests/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_affiliate_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /affiliate_requests/approve_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_all_affiliate_requests_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[6,"approve_all"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /affiliate_requests/approve_all(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_all_affiliate_requests_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[6,"approve_all"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/feature_announcement_campaigns/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_api_internal_admin_feature_announcement_campaign_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_announcement_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/feature_announcement_campaigns/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_api_internal_admin_feature_announcement_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_announcement_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/review_videos/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_api_mobile_review_video_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"review_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/review_videos/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_api_mobile_review_video_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"review_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/marketing_actions/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_api_v2_marketing_action_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/marketing_actions/:id/approve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_api_v2_marketing_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions/:id/approve.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_product_marketing_action_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions/:id/approve.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const approve_product_marketing_action_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"approve"],[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /audience(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audience"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /audience(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audience"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/audience(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"audience"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/audience(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"audience"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /audience/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_export_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /audience/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const audience_export_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"audience"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const balance_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /payouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const balance_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /paypal/billing_agreement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_agreement_paypal_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"billing_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /paypal/billing_agreement(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_agreement_paypal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"billing_agreement"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /paypal/billing_agreement_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_agreement_token_paypal_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"billing_agreement_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /paypal/billing_agreement_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const billing_agreement_token_paypal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"billing_agreement_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blackfriday(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blackfriday_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blackfriday"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /blackfriday(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blackfriday_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blackfriday"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/blob_url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blob_url_api_mobile_sales_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"blob_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/blob_url(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const blob_url_api_mobile_sales_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[6,"blob_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/block_buyer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_buyer_api_internal_admin_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block_buyer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/block_buyer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const block_buyer_api_internal_admin_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"block_buyer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /braintree/client_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const braintree_client_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"client_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /braintree/client_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const braintree_client_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"client_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /braintree/generate_transient_customer_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const braintree_generate_transient_customer_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"generate_transient_customer_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /braintree/generate_transient_customer_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const braintree_generate_transient_customer_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"generate_transient_customer_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:bundle_id/content(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_content_url = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:bundle_id/content(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_content_path = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:bundle_id/product(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_product_url = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"product"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:bundle_id/product(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_product_path = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"product"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:bundle_id/share(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_share_url = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:bundle_id/share(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const bundle_share_path = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /button(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const button_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"button"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /button(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const button_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"button"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mobile/analytics/by_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_date_api_mobile_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"by_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/analytics/by_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_date_api_mobile_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"by_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/analytics/by_referral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_referral_api_mobile_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"by_referral"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/analytics/by_referral(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_referral_api_mobile_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"by_referral"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/analytics/by_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_state_api_mobile_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"by_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/analytics/by_state(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const by_state_api_mobile_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"by_state"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/google_calendar/calendar_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_list_integrations_google_calendar_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google_calendar"],[2,[7,"/"],[2,[6,"calendar_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/google_calendar/calendar_list(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const calendar_list_integrations_google_calendar_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google_calendar"],[2,[7,"/"],[2,[6,"calendar_list"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /calls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const call_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"calls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/feature_announcement_campaigns/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_api_internal_admin_feature_announcement_campaign_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_announcement_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/feature_announcement_campaigns/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_api_internal_admin_feature_announcement_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_announcement_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/scheduled_payouts/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_api_internal_admin_scheduled_payout_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_payouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/scheduled_payouts/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_api_internal_admin_scheduled_payout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_payouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/marketing_actions/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_api_v2_marketing_action_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/marketing_actions/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_api_v2_marketing_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dropbox_files/cancel_upload/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_dropbox_file_upload_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dropbox_files"],[2,[7,"/"],[2,[6,"cancel_upload"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dropbox_files/cancel_upload/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_dropbox_file_upload_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dropbox_files"],[2,[7,"/"],[2,[6,"cancel_upload"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /follow/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_follow_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"follow"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /follow/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_follow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"follow"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/piracy_reports/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_piracy_report_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/piracy_reports/:id/cancel(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_piracy_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/cancel_preorder_by_seller(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_preorder_by_seller_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_preorder_by_seller"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/cancel_preorder_by_seller(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_preorder_by_seller_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_preorder_by_seller"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions/:id/cancel.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_product_marketing_action_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions/:id/cancel.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_product_marketing_action_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel"],[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/cancel_subscription(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_subscription_api_internal_admin_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/cancel_subscription(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_subscription_api_internal_admin_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"cancel_subscription"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/cancel(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cancel_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"cancel"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /careers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const careers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"careers"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /careers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const careers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"careers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /checkout/upsells/cart_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cart_item_checkout_upsells_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[6,"cart_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/upsells/cart_item(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cart_item_checkout_upsells_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[6,"cart_item"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /cart_items_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cart_items_count_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cart_items_count"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /cart_items_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const cart_items_count_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cart_items_count"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/change_can_contact(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_can_contact_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_can_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/change_can_contact(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_can_contact_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_can_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/change_can_contact(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_can_contact_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_can_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/change_can_contact(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const change_can_contact_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_can_contact"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /charge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charge_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"charge"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /charge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charge_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"charge"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /charge_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charge_data_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"charge_data"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /charge_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charge_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"charge_data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /preorders/:id/charge_preorder(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charge_preorder_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preorders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"charge_preorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /preorders/:id/charge_preorder(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const charge_preorder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"preorders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"charge_preorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chatgpt/v1/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatgpt_v1_mcp_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chatgpt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /chatgpt/v1/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatgpt_v1_mcp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chatgpt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /chatgpt/v1/oauth2/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatgpt_v1_oauth2_register_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chatgpt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /chatgpt/v1/oauth2/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatgpt_v1_oauth2_register_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chatgpt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /chatgpt/v1/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatgpt_v1_status_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chatgpt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /chatgpt/v1/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const chatgpt_v1_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"chatgpt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/sendgrid_emails/check_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_status_api_internal_admin_sendgrid_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sendgrid_emails"],[2,[7,"/"],[2,[6,"check_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/sendgrid_emails/check_status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_status_api_internal_admin_sendgrid_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sendgrid_emails"],[2,[7,"/"],[2,[6,"check_status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/check_twitter_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_twitter_link_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"check_twitter_link"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/check_twitter_link(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const check_twitter_link_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"check_twitter_link"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /checkout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /checkout/discounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_discount_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/discounts/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_discount_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_discounts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_discounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout/form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"form"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout/returns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_return_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"returns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/returns/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_return_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"returns"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/upsells/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsell_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/upsells/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsell_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/upsells/:upsell_id/pause(.:format)
 * @param {any} upsell_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsell_pause_url = /*#__PURE__*/ __jsr.r({"upsell_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[3,"upsell_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/upsells/:upsell_id/pause(.:format)
 * @param {any} upsell_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsell_pause_path = /*#__PURE__*/ __jsr.r({"upsell_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[3,"upsell_id"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/upsells(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsells_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/upsells(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsells_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout/upsells/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsells_product_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/upsells/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsells_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/upsells/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsells_products_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/upsells/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const checkout_upsells_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/churn(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const churn_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"churn"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/churn(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const churn_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"churn"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /claude(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claude_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"claude"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /claude(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claude_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"claude"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /claude/v1/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claude_v1_mcp_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"claude"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /claude/v1/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claude_v1_mcp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"claude"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /claude/v1/oauth2/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claude_v1_oauth2_register_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"claude"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /claude/v1/oauth2/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claude_v1_oauth2_register_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"claude"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /claude/v1/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claude_v1_status_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"claude"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /claude/v1/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const claude_v1_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"claude"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collaborators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborator_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /collaborators/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /collaborators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborators_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /collaborators(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborators_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /collaborators/incomings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborators_incoming_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"incomings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /collaborators/incomings/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborators_incoming_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"incomings"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /collaborators/incomings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborators_incomings_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"incomings"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /collaborators/incomings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const collaborators_incomings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"incomings"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/comments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comments_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /commissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"commissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /commissions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const commission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"commissions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /communities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const communities_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"communities"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /communities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const communities_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"communities"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrations/circle/communities_and_space_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const communities_and_space_groups_integrations_circle_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"circle"],[2,[7,"/"],[2,[6,"communities_and_space_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/circle/communities_and_space_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const communities_and_space_groups_integrations_circle_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"circle"],[2,[7,"/"],[2,[6,"communities_and_space_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/circle/communities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const communities_integrations_circle_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"circle"],[2,[7,"/"],[2,[6,"communities"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/circle/communities(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const communities_integrations_circle_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"circle"],[2,[7,"/"],[2,[6,"communities"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /communities/:seller_id/:community_id(.:format)
 * @param {any} seller_id
 * @param {any} community_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_url = /*#__PURE__*/ __jsr.r({"seller_id":{"r":true},"community_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"seller_id"],[2,[7,"/"],[2,[3,"community_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /communities/:seller_id/:community_id(.:format)
 * @param {any} seller_id
 * @param {any} community_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_path = /*#__PURE__*/ __jsr.r({"seller_id":{"r":true},"community_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"seller_id"],[2,[7,"/"],[2,[3,"community_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /communities/:community_id/chat_messages/:id(.:format)
 * @param {any} community_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_chat_message_url = /*#__PURE__*/ __jsr.r({"community_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"community_id"],[2,[7,"/"],[2,[6,"chat_messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /communities/:community_id/chat_messages/:id(.:format)
 * @param {any} community_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_chat_message_path = /*#__PURE__*/ __jsr.r({"community_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"community_id"],[2,[7,"/"],[2,[6,"chat_messages"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /communities/:community_id/chat_messages(.:format)
 * @param {any} community_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_chat_messages_url = /*#__PURE__*/ __jsr.r({"community_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"community_id"],[2,[7,"/"],[2,[6,"chat_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /communities/:community_id/chat_messages(.:format)
 * @param {any} community_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_chat_messages_path = /*#__PURE__*/ __jsr.r({"community_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"community_id"],[2,[7,"/"],[2,[6,"chat_messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /communities/:community_id/last_read_chat_message(.:format)
 * @param {any} community_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_last_read_chat_message_url = /*#__PURE__*/ __jsr.r({"community_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"community_id"],[2,[7,"/"],[2,[6,"last_read_chat_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /communities/:community_id/last_read_chat_message(.:format)
 * @param {any} community_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_last_read_chat_message_path = /*#__PURE__*/ __jsr.r({"community_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"community_id"],[2,[7,"/"],[2,[6,"last_read_chat_message"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /communities/:community_id/notification_settings(.:format)
 * @param {any} community_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_notification_settings_url = /*#__PURE__*/ __jsr.r({"community_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"community_id"],[2,[7,"/"],[2,[6,"notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /communities/:community_id/notification_settings(.:format)
 * @param {any} community_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const community_notification_settings_path = /*#__PURE__*/ __jsr.r({"community_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"communities"],[2,[7,"/"],[2,[3,"community_id"],[2,[7,"/"],[2,[6,"notification_settings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/commissions/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_mobile_commission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"commissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/commissions/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_api_mobile_commission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"commissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /commissions/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_commission_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"commissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /commissions/:id/complete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const complete_commission_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"commissions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"complete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/compliance_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_info_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"compliance_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/compliance_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compliance_info_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"compliance_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/products/comps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comps_api_v2_links_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"comps"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/products/comps(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const comps_api_v2_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"comps"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /offer_codes/compute_discount(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_discount_offer_codes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_codes"],[2,[7,"/"],[2,[6,"compute_discount"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /offer_codes/compute_discount(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const compute_discount_offer_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_codes"],[2,[7,"/"],[2,[6,"compute_discount"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /orders/:id/confirm_error(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_error_order_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_error"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:id/confirm_error(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_error_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_error"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /follow/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_follow_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"follow"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /follow/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_follow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"follow"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_order_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/confirm(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:purchase_id/invoice/confirm(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_purchase_invoice_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"invoice"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:purchase_id/invoice/confirm(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_purchase_invoice_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"invoice"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/confirm_receipt_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_receipt_email_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_receipt_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/confirm_receipt_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_receipt_email_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"confirm_receipt_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /confirm-redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_redirect_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm-redirect"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /confirm-redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_redirect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm-redirect"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/totp/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_settings_totp_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/totp/confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const confirm_settings_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /paypal/connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connect_paypal_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /paypal/connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const connect_paypal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"connect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /consumption_analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consumption_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"consumption_analytics"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /consumption_analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const consumption_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"consumption_analytics"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/piracy_reports/:id/counter_notice(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counter_notice_api_internal_admin_piracy_report_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"counter_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/piracy_reports/:id/counter_notice(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const counter_notice_api_internal_admin_piracy_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"counter_notice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/create_comment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_comment_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"create_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/create_comment(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_comment_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"create_comment"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dropbox_files/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_dropbox_file_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dropbox_files"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dropbox_files/create(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_dropbox_file_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dropbox_files"],[2,[7,"/"],[2,[6,"create"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /bundles/create_from_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_from_email_bundles_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[6,"create_from_email"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/create_from_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const create_from_email_bundles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[6,"create_from_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/credits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credits_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/credits(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const credits_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"credits"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /crossdomain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crossdomain_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"crossdomain"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /crossdomain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const crossdomain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"crossdomain"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/current_user_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_user_data_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"current_user_data"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/current_user_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const current_user_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"current_user_data"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /coffee(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_coffee_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"coffee"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /coffee(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_coffee_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"coffee"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_confirm_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /confirm(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_confirm_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"confirm"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /affiliate_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_create_affiliate_request_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /affiliate_requests(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_create_affiliate_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/comments(.:format)
 * @param {any} post_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_create_post_comment_url = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /posts/:post_id/comments(.:format)
 * @param {any} post_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_create_post_comment_path = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/comments/:id(.:format)
 * @param {any} post_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_delete_post_comment_url = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /posts/:post_id/comments/:id(.:format)
 * @param {any} post_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_delete_post_comment_path = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /d/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_download_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /d/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_download_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/index.m3u8(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_hls_playlist_for_product_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[6,"index"],[2,[8,"."],[2,[6,"m3u8"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/index.m3u8(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_hls_playlist_for_product_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[6,"index"],[2,[8,"."],[2,[6,"m3u8"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /affiliates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_new_affiliate_request_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /affiliates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_new_affiliate_request_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/comments(.:format)
 * @param {any} post_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_post_comments_url = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /posts/:post_id/comments(.:format)
 * @param {any} post_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_post_comments_path = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"comments"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/send_to_kindle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_send_to_kindle_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_kindle"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/send_to_kindle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_send_to_kindle_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_kindle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_subscribe_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /subscribe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_subscribe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts/:post_id/comments/:id(.:format)
 * @param {any} post_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_update_post_comment_url = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /posts/:post_id/comments/:id(.:format)
 * @param {any} post_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_update_post_comment_path = /*#__PURE__*/ __jsr.r({"post_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"post_id"],[2,[7,"/"],[2,[6,"comments"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/change_purchaser(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_change_purchaser_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_purchaser"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/change_purchaser(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_change_purchaser_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_purchaser"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/check_purchaser(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_check_purchaser_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_purchaser"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/check_purchaser(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_check_purchaser_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_purchaser"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /zip/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_download_archive_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /zip/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_download_archive_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/product_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_download_product_files_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/product_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_download_product_files_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/:subtitle_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {any} subtitle_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_download_subtitle_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"subtitle_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[3,"subtitle_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/:subtitle_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {any} subtitle_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_download_subtitle_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"subtitle_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[3,"subtitle_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/expired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_expired_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"expired"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/expired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_expired_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"expired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/membership_inactive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_membership_inactive_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"membership_inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/membership_inactive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_membership_inactive_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"membership_inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /read/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_read_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"read"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /read/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_read_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"read"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /read/:id/:product_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_read_for_product_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"read"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /read/:id/:product_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_read_for_product_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"read"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/rental_expired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_rental_expired_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rental_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/rental_expired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_rental_expired_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rental_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/save_last_content_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_save_last_content_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_last_content_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/save_last_content_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_save_last_content_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_last_content_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/stream.smil(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_smil_for_product_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[6,"stream"],[2,[8,"."],[2,[6,"smil"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/stream.smil(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_smil_for_product_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[6,"stream"],[2,[8,"."],[2,[6,"smil"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_stream_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_stream_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/:product_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_stream_page_for_product_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/:product_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_stream_page_for_product_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/:subtitle_file_id/captions.vtt(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {any} subtitle_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_subtitle_file_vtt_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"subtitle_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[3,"subtitle_file_id"],[2,[7,"/"],[2,[6,"captions"],[2,[8,"."],[2,[6,"vtt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/:subtitle_file_id/captions.vtt(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {any} subtitle_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_url_redirect_subtitle_file_vtt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"subtitle_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[3,"subtitle_file_id"],[2,[7,"/"],[2,[6,"captions"],[2,[8,"."],[2,[6,"vtt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /custom_domain/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_verifications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"custom_domain"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /custom_domain/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_verifications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"custom_domain"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /p/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_view_post_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /p/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_domain_view_post_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v2/products/:id/custom_html(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_html_api_v2_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom_html"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/products/:id/custom_html(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_html_api_v2_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom_html"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/products/:id/custom_html/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_html_edit_api_v2_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom_html"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/products/:id/custom_html/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const custom_html_edit_api_v2_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"custom_html"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/charges/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_charges_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /customers/charges/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_charges_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"charges"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/customer_emails/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_emails_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"customer_emails"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /customers/customer_emails/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_emails_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"customer_emails"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customers/sale/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_sale_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"sale"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /customers/sale/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_sale_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"sale"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /customer_surcharge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_surcharges_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customer_surcharge"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /customer_surcharge(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customer_surcharges_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customer_surcharge"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_url = /*#__PURE__*/ __jsr.r({"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_path = /*#__PURE__*/ __jsr.r({"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"customers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customers/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_import_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /customers/import(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_import_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"import"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/import_manually_entered_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_import_manually_entered_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"import_manually_entered_emails"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /customers/import_manually_entered_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_import_manually_entered_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"import_manually_entered_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/:link_id(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_link_id_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"link_id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /customers/:link_id(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_link_id_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"link_id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/paged(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_paged_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"paged"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /customers/paged(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const customers_paged_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"paged"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /dashboard(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/active_members_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_active_members_count_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"active_members_count"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/active_members_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_active_members_count_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"active_members_count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/consumption(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_consumption_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"consumption"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/consumption(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_consumption_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"consumption"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/customers_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_customers_count_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"customers_count"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/customers_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_customers_count_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"customers_count"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/dismiss_getting_started_checklist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_dismiss_getting_started_checklist_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dismiss_getting_started_checklist"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/dismiss_getting_started_checklist(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_dismiss_getting_started_checklist_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"dismiss_getting_started_checklist"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/download_tax_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_download_tax_form_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"download_tax_form"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/download_tax_form(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_download_tax_form_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"download_tax_form"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/monthly_recurring_revenue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_monthly_recurring_revenue_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"monthly_recurring_revenue"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/monthly_recurring_revenue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_monthly_recurring_revenue_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"monthly_recurring_revenue"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/piracy_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_piracy_reports_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/piracy_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_piracy_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/total_revenue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_total_revenue_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"total_revenue"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/total_revenue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_total_revenue_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"total_revenue"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/utm_links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_utm_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/utm_links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_utm_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/utm_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_utm_links_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"utm_links"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/utm_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dashboard_utm_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"utm_links"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mobile/analytics/data_by_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_by_date_api_mobile_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"data_by_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/analytics/data_by_date(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const data_by_date_api_mobile_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"data_by_date"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/deactivate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivate_account_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/deactivate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deactivate_account_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"deactivate"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /collaborators/incomings/:id/decline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_collaborators_incoming_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"incomings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /collaborators/incomings/:id/decline(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decline_collaborators_incoming_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"incomings"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"decline"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/licenses/decrement_uses_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decrement_uses_count_api_v2_licenses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"decrement_uses_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/licenses/decrement_uses_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const decrement_uses_count_api_v2_licenses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"decrement_uses_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/feature_announcement_campaigns/:id/deliver(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deliver_api_internal_admin_feature_announcement_campaign_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_announcement_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deliver"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/feature_announcement_campaigns/:id/deliver(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deliver_api_internal_admin_feature_announcement_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_announcement_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"deliver"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/products/:link_id/builds/deploy(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deploy_api_v2_link_product_builds_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"builds"],[2,[7,"/"],[2,[6,"deploy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/products/:link_id/builds/deploy(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const deploy_api_v2_link_product_builds_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"builds"],[2,[7,"/"],[2,[6,"deploy"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /imported_customers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_imported_customer_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"imported_customers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /imported_customers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_imported_customer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"imported_customers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_out(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const destroy_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_out"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v2/licenses/disable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_api_v2_licenses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/licenses/disable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_api_v2_licenses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/products/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_api_v2_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/products/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_api_v2_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/utm_links/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_api_v2_utm_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/utm_links/:id/disable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_api_v2_utm_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:id/disable_downloads_for_all_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_downloads_for_all_files_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_downloads_for_all_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id/disable_downloads_for_all_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disable_downloads_for_all_files_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"disable_downloads_for_all_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /paypal/disconnect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnect_paypal_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /paypal/disconnect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnect_paypal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal"],[2,[7,"/"],[2,[6,"disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/stripe/disconnect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnect_settings_stripe_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/stripe/disconnect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const disconnect_settings_stripe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"disconnect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /discover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /discover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /discover/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_categories_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /discover/categories(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_categories_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover"],[2,[7,"/"],[2,[6,"categories"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /discover_search_autocomplete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_search_autocomplete_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover_search_autocomplete"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /discover_search_autocomplete(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_search_autocomplete_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"discover_search_autocomplete"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /*taxonomy(.:format)
 * @param {any} taxonomy
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_taxonomy_url = /*#__PURE__*/ __jsr.r({"taxonomy":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"taxonomy"]],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /*taxonomy(.:format)
 * @param {any} taxonomy
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const discover_taxonomy_path = /*#__PURE__*/ __jsr.r({"taxonomy":{"r":true},"format":{}}, [2,[7,"/"],[2,[5,[3,"taxonomy"]],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /docs/cli/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_cli_pages_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"cli"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /docs/cli/pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const docs_cli_pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"docs"],[2,[7,"/"],[2,[6,"cli"],[2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /product_files_utility/folder_archive/:folder_id(.:format)
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_folder_archive_url = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_files_utility"],[2,[7,"/"],[2,[6,"folder_archive"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /product_files_utility/folder_archive/:folder_id(.:format)
 * @param {any} folder_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_folder_archive_path = /*#__PURE__*/ __jsr.r({"folder_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_files_utility"],[2,[7,"/"],[2,[6,"folder_archive"],[2,[7,"/"],[2,[3,"folder_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /product_files_utility/product_files/:product_id(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_product_files_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_files_utility"],[2,[7,"/"],[2,[6,"product_files"],[2,[7,"/"],[2,[3,"product_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /product_files_utility/product_files/:product_id(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_product_files_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_files_utility"],[2,[7,"/"],[2,[6,"product_files"],[2,[7,"/"],[2,[3,"product_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /payouts/taxes/:year/:form_type/download(.:format)
 * @param {any} year
 * @param {any} form_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_tax_form_url = /*#__PURE__*/ __jsr.r({"year":{"r":true},"form_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"year"],[2,[7,"/"],[2,[3,"form_type"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /payouts/taxes/:year/:form_type/download(.:format)
 * @param {any} year
 * @param {any} form_type
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const download_tax_form_path = /*#__PURE__*/ __jsr.r({"year":{"r":true},"form_type":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"year"],[2,[7,"/"],[2,[3,"form_type"],[2,[7,"/"],[2,[6,"download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dpa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dpa_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dpa"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /dpa(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dpa_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dpa"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /emails/drafts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drafts_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /emails/drafts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const drafts_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"drafts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dropbox_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dropbox_files_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dropbox_files"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /dropbox_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const dropbox_files_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dropbox_files"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /affiliates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_affiliate_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /affiliates/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_affiliate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:bundle_id/content/edit(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_content_url = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:bundle_id/content/edit(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_content_path = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:bundle_id/product/edit(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_product_url = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"product"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:bundle_id/product/edit(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_product_path = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"product"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:bundle_id/share/edit(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_share_url = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:bundle_id/share/edit(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_bundle_share_path = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"share"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /collaborators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_collaborator_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /collaborators/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_collaborator_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:id/edit/content(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_content_bundle_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:id/edit/content(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_content_bundle_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[6,"content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/utm_links/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dashboard_utm_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/utm_links/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_dashboard_utm_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /emails/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/applications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_oauth_application_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/applications/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_oauth_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/:slug/edit(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_page_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pages/:slug/edit(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/remaining_call_availabilities/:id/edit.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_product_remaining_call_availability_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"remaining_call_availabilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/remaining_call_availabilities/:id/edit.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_product_remaining_call_availability_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"remaining_call_availabilities"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:id/edit/share(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_share_bundle_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:id/edit/share(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_share_bundle_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[2,[7,"/"],[2,[6,"share"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/forgot_password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"forgot_password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/forgot_password/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"forgot_password"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/edit(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /workflows/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_workflow_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/:id/edit(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const edit_workflow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"edit"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const embed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /v2/licenses/enable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_api_v2_licenses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/licenses/enable(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_api_v2_licenses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/products/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_api_v2_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/products/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_api_v2_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/utm_links/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_api_v2_utm_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/utm_links/:id/enable(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const enable_api_v2_utm_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"enable"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /events/track_user_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_track_user_action_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"track_user_action"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /events/track_user_action(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const events_track_user_action_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"events"],[2,[7,"/"],[2,[6,"track_user_action"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/low_balance_probation_recoveries/execute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_api_internal_admin_low_balance_probation_recoveries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"low_balance_probation_recoveries"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/low_balance_probation_recoveries/execute(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_api_internal_admin_low_balance_probation_recoveries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"low_balance_probation_recoveries"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/scheduled_payouts/:id/execute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_api_internal_admin_scheduled_payout_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_payouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/scheduled_payouts/:id/execute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_api_internal_admin_scheduled_payout_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"scheduled_payouts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/marketing_actions/:id/execute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_api_v2_marketing_action_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/marketing_actions/:id/execute(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_api_v2_marketing_action_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions/:id/execute.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_product_marketing_action_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions/:id/execute.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const execute_product_marketing_action_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"execute"],[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /affiliates/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_affiliates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /affiliates/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_affiliates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /purchases/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_purchases_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/export(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const export_purchases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"export"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product_files_utility/external_link_title(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_link_title_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_files_utility"],[2,[7,"/"],[2,[6,"external_link_title"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /product_files_utility/external_link_title(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const external_link_title_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_files_utility"],[2,[7,"/"],[2,[6,"external_link_title"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /favicon.ico(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favicon_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"favicon"],[2,[8,"."],[2,[6,"ico"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /favicon.ico(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const favicon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"favicon"],[2,[8,"."],[2,[6,"ico"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const features_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /features(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const features_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"features"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/products/:id/files/:file_id/download_url(.:format)
 * @param {any} id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_download_api_internal_admin_product_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"download_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/products/:id/files/:file_id/download_url(.:format)
 * @param {any} id
 * @param {any} file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const file_download_api_internal_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"files"],[2,[7,"/"],[2,[3,"file_id"],[2,[7,"/"],[2,[6,"download_url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders/:id/finalize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalize_order_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /orders/:id/finalize(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const finalize_order_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"finalize"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/flag_for_tos_violation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flag_for_tos_violation_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"flag_for_tos_violation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/flag_for_tos_violation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const flag_for_tos_violation_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"flag_for_tos_violation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /follow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /follow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /follow_from_embed_form
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_from_embed_form_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"follow_from_embed_form"]], true);

/**
 * Generates rails route to
 * /follow_from_embed_form
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_from_embed_form_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"follow_from_embed_form"]]);

/**
 * Generates rails route to
 * /follow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_user_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /follow(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_user_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /follow_from_embed_form
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_user_from_embed_form_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"follow_from_embed_form"]], true);

/**
 * Generates rails route to
 * /follow_from_embed_form
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_user_from_embed_form_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[6,"follow_from_embed_form"]]);

/**
 * Generates rails route to
 * /:username/follow(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_user_page_url = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /:username/follow(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follow_user_page_path = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"follow"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /followers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follower_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"followers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /followers/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const follower_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"followers"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /followers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const followers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /followers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const followers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /braintree/generate_transient_customer_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_braintree_transient_customer_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"generate_transient_customer_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /braintree/generate_transient_customer_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const generate_braintree_transient_customer_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"braintree"],[2,[7,"/"],[2,[6,"generate_transient_customer_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /github_stars(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const github_stars_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"github_stars"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /github_stars(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const github_stars_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"github_stars"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /global_affiliates/product_eligibility/:url(.:format)
 * @param {any} url
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const global_affiliates_product_eligibility_url = /*#__PURE__*/ __jsr.r({"url":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"global_affiliates"],[2,[7,"/"],[2,[6,"product_eligibility"],[2,[7,"/"],[2,[3,"url"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /global_affiliates/product_eligibility/:url(.:format)
 * @param {any} url
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const global_affiliates_product_eligibility_path = /*#__PURE__*/ __jsr.r({"url":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"global_affiliates"],[2,[7,"/"],[2,[6,"product_eligibility"],[2,[7,"/"],[2,[3,"url"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/url_redirects/:id/grant_download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_download_api_internal_admin_url_redirect_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"url_redirects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"grant_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/url_redirects/:id/grant_download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grant_download_api_internal_admin_url_redirect_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"url_redirects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"grant_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /grmc-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grmc_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"grmc-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /grmc-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const grmc_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"grmc-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /gumclaw(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumclaw_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gumclaw"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /gumclaw(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumclaw_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"gumclaw"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /js/gumroad(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /js/gumroad(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /js/gumroad-analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad-analytics"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /js/gumroad-analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad-analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog/p/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_blog_post_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /blog/p/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_blog_post_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /blog/p(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_blog_posts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"p"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /blog/p(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_blog_posts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[2,[7,"/"],[2,[6,"p"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /blog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_blog_root_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /blog(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_blog_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"blog"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /js/gumroad-embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_embed_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad-embed"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /js/gumroad-embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_embed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad-embed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /js/gumroad-multioverlay(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_multioverlay_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad-multioverlay"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /js/gumroad-multioverlay(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_multioverlay_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad-multioverlay"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /js/gumroad-overlay(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_overlay_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad-overlay"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /js/gumroad-overlay(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const gumroad_overlay_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"js"],[2,[7,"/"],[2,[6,"gumroad-overlay"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /hackathon(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hackathon_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hackathon"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /hackathon(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hackathon_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"hackathon"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /healthcheck(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /healthcheck(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /healthcheck/abandoned_cart_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_abandoned_cart_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"abandoned_cart_emails"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /healthcheck/abandoned_cart_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_abandoned_cart_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"abandoned_cart_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /healthcheck/apple_pay_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_apple_pay_domain_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"apple_pay_domain"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /healthcheck/apple_pay_domain(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_apple_pay_domain_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"apple_pay_domain"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /healthcheck/long_running_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_long_running_jobs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"long_running_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /healthcheck/long_running_jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_long_running_jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"long_running_jobs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /healthcheck/payouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_payouts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"payouts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /healthcheck/payouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_payouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"payouts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /healthcheck/paypal_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_paypal_balance_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"paypal_balance"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /healthcheck/paypal_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_paypal_balance_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"paypal_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /healthcheck/purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_purchases_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /healthcheck/purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_purchases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /healthcheck/sidekiq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_sidekiq_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"sidekiq"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /healthcheck/sidekiq(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_sidekiq_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"sidekiq"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /healthcheck/stripe_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_stripe_balance_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"stripe_balance"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /healthcheck/stripe_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const healthcheck_stripe_balance_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"healthcheck"],[2,[7,"/"],[2,[6,"stripe_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /help/article/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_article_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"article"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /help/article/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_article_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"article"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/article(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_articles_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"article"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /help/article(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_articles_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"article"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /help/category/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_category_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /help/category/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_category_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"category"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /help/contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_contact_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /help/contact(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_contact_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[2,[7,"/"],[2,[6,"contact"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_root_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /help(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const help_center_root_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"help"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/index.m3u8(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hls_playlist_for_product_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[6,"index"],[2,[8,"."],[2,[6,"m3u8"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/index.m3u8(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hls_playlist_for_product_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[6,"index"],[2,[8,"."],[2,[6,"m3u8"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/products/:id/hold_sales(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hold_sales_api_internal_admin_product_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hold_sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/products/:id/hold_sales(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const hold_sales_api_internal_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"hold_sales"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ifttt/v1/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ifttt_v1_status_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ifttt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /ifttt/v1/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ifttt_v1_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ifttt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /ifttt/v1/triggers/sale(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ifttt_v1_triggers_sale_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ifttt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"triggers"],[2,[7,"/"],[2,[6,"sale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /ifttt/v1/triggers/sale(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ifttt_v1_triggers_sale_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ifttt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"triggers"],[2,[7,"/"],[2,[6,"sale"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /ifttt/v1/user/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ifttt_v1_user_info_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ifttt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /ifttt/v1/user/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ifttt_v1_user_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ifttt"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /affiliate_requests/:id/ignore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ignore_affiliate_request_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ignore"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /affiliate_requests/:id/ignore(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ignore_affiliate_request_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliate_requests"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"ignore"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /imported_customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imported_customers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"imported_customers"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /imported_customers(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const imported_customers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"imported_customers"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /posts/:id/increment_post_views(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const increment_post_views_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"increment_post_views"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /posts/:id/increment_post_views(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const increment_post_views_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"increment_post_views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:id/increment_views(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const increment_views_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"increment_views"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id/increment_views(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const increment_views_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"increment_views"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:key.txt(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indexnow_key_url = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"key"],[2,[8,"."],[2,[6,"txt"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /:key.txt(.:format)
 * @param {any} key
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const indexnow_key_path = /*#__PURE__*/ __jsr.r({"key":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"key"],[2,[8,"."],[2,[6,"txt"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const info_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const info_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /instagram/data_deletion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagram_data_deletion_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"data_deletion"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /instagram/data_deletion(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagram_data_deletion_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"data_deletion"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instagram/data_deletion/:confirmation_code(.:format)
 * @param {any} confirmation_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagram_data_deletion_status_url = /*#__PURE__*/ __jsr.r({"confirmation_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"data_deletion"],[2,[7,"/"],[2,[3,"confirmation_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /instagram/data_deletion/:confirmation_code(.:format)
 * @param {any} confirmation_code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagram_data_deletion_status_path = /*#__PURE__*/ __jsr.r({"confirmation_code":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"data_deletion"],[2,[7,"/"],[2,[3,"confirmation_code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /instagram/deauthorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagram_deauthorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"deauthorize"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /instagram/deauthorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instagram_deauthorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"deauthorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /instant_payouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instant_payouts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instant_payouts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /instant_payouts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const instant_payouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"instant_payouts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/agent/actions/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_action_status_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"actions"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/agent/actions/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_action_status_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"actions"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/agent/actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_actions_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/agent/actions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_actions_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"actions"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/agent/conversations/latest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_conversations_latest_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"latest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/agent/conversations/latest(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_conversations_latest_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"conversations"],[2,[7,"/"],[2,[6,"latest"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/agent/custom_html_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_custom_html_preview_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"custom_html_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/agent/custom_html_preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_custom_html_preview_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"custom_html_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/agent/custom_html_previews/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_custom_html_preview_document_url = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"custom_html_previews"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/agent/custom_html_previews/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_custom_html_preview_document_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"custom_html_previews"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/agent/messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_messages_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/agent/messages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_messages_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"messages"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/agent/messages/stream(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_messages_stream_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/agent/messages/stream(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_messages_stream_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"messages"],[2,[7,"/"],[2,[6,"stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/agent/turns/:client_turn_id(.:format)
 * @param {any} client_turn_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_turn_status_url = /*#__PURE__*/ __jsr.r({"client_turn_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"turns"],[2,[7,"/"],[2,[3,"client_turn_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/agent/turns/:client_turn_id(.:format)
 * @param {any} client_turn_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_agent_turn_status_path = /*#__PURE__*/ __jsr.r({"client_turn_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"agent"],[2,[7,"/"],[2,[6,"turns"],[2,[7,"/"],[2,[3,"client_turn_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/ai_product_details_generations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_ai_product_details_generations_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_product_details_generations"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/ai_product_details_generations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_ai_product_details_generations_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"ai_product_details_generations"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/installments/:id/audience_count(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_audience_count_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/installments/:id/audience_count(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_audience_count_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"audience_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/installments/:id/clicked_urls(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_clicked_urls_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clicked_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/installments/:id/clicked_urls(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_clicked_urls_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"clicked_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/installments/:id/non_opener_resend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_non_opener_resend_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"non_opener_resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/installments/:id/non_opener_resend(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_non_opener_resend_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"non_opener_resend"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/installments/:id/preview_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_preview_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/installments/:id/preview_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_preview_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/installments/recipient_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_recipient_count_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[6,"recipient_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/installments/recipient_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_recipient_count_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[6,"recipient_count"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/installments/:id/remaining_send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_remaining_send_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remaining_send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/installments/:id/remaining_send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_installment_remaining_send_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"installments"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"remaining_send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/products/:product_id/existing_product_files(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_existing_product_files_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"existing_product_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/products/:product_id/existing_product_files(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_existing_product_files_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"existing_product_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/products/:product_id/product_posts(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_product_posts_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/products/:product_id/product_posts(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_product_posts_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"product_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/product_public_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_public_files_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"product_public_files"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /internal/product_public_files(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_public_files_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"product_public_files"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/products/:product_id/receipt_preview(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_receipt_preview_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"receipt_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/products/:product_id/receipt_preview(.:format)
 * @param {any} product_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_receipt_preview_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"receipt_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/product_review_videos/:product_review_video_id/approvals(.:format)
 * @param {any} product_review_video_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_review_video_approvals_url = /*#__PURE__*/ __jsr.r({"product_review_video_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[3,"product_review_video_id"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/product_review_videos/:product_review_video_id/approvals(.:format)
 * @param {any} product_review_video_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_review_video_approvals_path = /*#__PURE__*/ __jsr.r({"product_review_video_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[3,"product_review_video_id"],[2,[7,"/"],[2,[6,"approvals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/product_review_videos/:product_review_video_id/rejections(.:format)
 * @param {any} product_review_video_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_review_video_rejections_url = /*#__PURE__*/ __jsr.r({"product_review_video_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[3,"product_review_video_id"],[2,[7,"/"],[2,[6,"rejections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/product_review_videos/:product_review_video_id/rejections(.:format)
 * @param {any} product_review_video_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_product_review_video_rejections_path = /*#__PURE__*/ __jsr.r({"product_review_video_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[3,"product_review_video_id"],[2,[7,"/"],[2,[6,"rejections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/customers/:purchase_id/single_customer_email(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_single_customer_email_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"single_customer_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/customers/:purchase_id/single_customer_email(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const internal_single_customer_email_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"single_customer_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/payouts/issue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issue_api_internal_admin_payouts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"issue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/payouts/issue(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const issue_api_internal_admin_payouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"issue"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jobs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /jobs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const jobs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"jobs"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrations/discord/join_server(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_server_integrations_discord_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"discord"],[2,[7,"/"],[2,[6,"join_server"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/discord/join_server(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const join_server_integrations_discord_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"discord"],[2,[7,"/"],[2,[6,"join_server"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /l/product-name/offer-code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_product_name_offer_code_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"product-name"],[2,[7,"/"],[2,[6,"offer-code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /l/product-name/offer-code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const l_product_name_offer_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[6,"product-name"],[2,[7,"/"],[2,[6,"offer-code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /landing/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_embed_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /landing/embed(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_embed_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /landing/products
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_products_url = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[6,"products"]]]], true);

/**
 * Generates rails route to
 * /landing/products
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_products_path = /*#__PURE__*/ __jsr.r({}, [2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[6,"products"]]]]);

/**
 * Generates rails route to
 * /landing/version(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_version_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /landing/version(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const landing_version_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /integrations/discord/leave_server(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leave_server_integrations_discord_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"discord"],[2,[7,"/"],[2,[6,"leave_server"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/discord/leave_server(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const leave_server_integrations_discord_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"discord"],[2,[7,"/"],[2,[6,"leave_server"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"library"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"library"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /library/purchase/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_archive_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /library/purchase/:id/archive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_archive_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"archive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /library/purchase/:id/delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_delete_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /library/purchase/:id/delete(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_delete_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"delete"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /library/purchase/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /library/purchase/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /library/purchase/:id/unarchive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_unarchive_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /library/purchase/:id/unarchive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const library_unarchive_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unarchive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /licenses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const license_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /licenses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const license_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /license-key-lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const license_key_lookup_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"license-key-lookup"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /license-key-lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const license_key_lookup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"license-key-lookup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /license_key_lookup_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const license_key_lookup_data_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"license_key_lookup_data"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /license_key_lookup_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const license_key_lookup_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"license_key_lookup_data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /links/:link_id/asset_previews/:id(.:format)
 * @param {any} link_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_asset_preview_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"asset_previews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:link_id/asset_previews/:id(.:format)
 * @param {any} link_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_asset_preview_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"asset_previews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:link_id/asset_previews(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_asset_previews_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"asset_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:link_id/asset_previews(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_asset_previews_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"asset_previews"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:link_id/in_app(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_mobile_tracking_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"in_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:link_id/in_app(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_mobile_tracking_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"in_app"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:link_id/thumbnails/:id(.:format)
 * @param {any} link_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_thumbnail_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"thumbnails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:link_id/thumbnails/:id(.:format)
 * @param {any} link_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_thumbnail_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"thumbnails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:link_id/thumbnails(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_thumbnails_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"thumbnails"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:link_id/thumbnails(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_thumbnails_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"thumbnails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:link_id/variants(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_variants_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:link_id/variants(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const link_variants_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"variants"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const links_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"links"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"links"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /login/passkey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_passkey_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"passkey"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /login/passkey(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_passkey_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"passkey"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /login/passkey/options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_passkey_options_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"passkey"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /login/passkey/options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const login_passkey_options_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"login"],[2,[7,"/"],[2,[6,"passkey"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /logout(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const logout_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"logout"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/licenses/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_api_internal_admin_licenses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/licenses/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_api_internal_admin_licenses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_api_internal_admin_purchases_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/lookup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const lookup_api_internal_admin_purchases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"lookup"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/:id/manage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_subscription_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /subscriptions/:id/manage(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const manage_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"manage"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /shipments/:purchase_id/mark_as_shipped(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_shipped_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"mark_as_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /shipments/:purchase_id/mark_as_shipped(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_shipped_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"shipments"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"mark_as_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/mark_as_shipped(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_shipped_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/mark_as_shipped(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_shipped_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/sales/:id/mark_as_shipped(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_shipped_api_v2_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/sales/:id/mark_as_shipped(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_as_shipped_api_v2_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"mark_as_shipped"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/mark_compliant(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_compliant_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"mark_compliant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/mark_compliant(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mark_compliant_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"mark_compliant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcp_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const mcp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /media_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_locations_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media_locations"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /media_locations(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const media_locations_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"media_locations"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /customers/missed_posts/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missed_posts_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"missed_posts"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /customers/missed_posts/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missed_posts_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"missed_posts"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/missed_posts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missed_posts_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"missed_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/missed_posts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const missed_posts_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"missed_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modal_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /modal(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const modal_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"modal"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /muse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muse_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"muse"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /muse(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muse_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"muse"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /muse/v1/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muse_v1_mcp_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"muse"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /muse/v1/mcp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muse_v1_mcp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"muse"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"mcp"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /muse/v1/oauth2/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muse_v1_oauth2_register_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"muse"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /muse/v1/oauth2/register(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muse_v1_oauth2_register_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"muse"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"oauth2"],[2,[7,"/"],[2,[6,"register"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /muse/v1/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muse_v1_status_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"muse"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /muse/v1/status(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const muse_v1_status_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"muse"],[2,[7,"/"],[2,[6,"v1"],[2,[7,"/"],[2,[6,"status"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const native_oauth_authorization_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/authorize/native(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const native_oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[2,[7,"/"],[2,[6,"native"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /affiliates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_affiliate_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /affiliates/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_affiliate_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/affiliates(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_affiliate_request_url = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"affiliates"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /:username/affiliates(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_affiliate_request_path = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"affiliates"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /collaborators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_collaborator_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /collaborators/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_collaborator_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"collaborators"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/utm_links/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dashboard_utm_link_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/utm_links/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_dashboard_utm_link_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"utm_links"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/applications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth_application_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/applications/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth_application_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/mobile_pre_authorization/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth_mobile_pre_authorization_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"mobile_pre_authorization"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/mobile_pre_authorization/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_oauth_mobile_pre_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"mobile_pre_authorization"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_page_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pages/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_page_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/piracy_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_piracy_report_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/piracy_reports/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_piracy_report_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_product_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_product_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/remaining_call_availabilities/new.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_product_remaining_call_availability_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"remaining_call_availabilities"],[2,[7,"/"],[2,[6,"new"],[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/remaining_call_availabilities/new.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_product_remaining_call_availability_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"remaining_call_availabilities"],[2,[7,"/"],[2,[6,"new"],[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:purchase_id/invoice/new(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_purchase_invoice_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"invoice"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:purchase_id/invoice/new(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_purchase_invoice_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"invoice"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_rails_conductor_inbound_email_source_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/:subscription_id/magic_link/new(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_subscription_magic_link_url = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"magic_link"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /subscriptions/:subscription_id/magic_link/new(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_subscription_magic_link_path = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"magic_link"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/confirmation/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/forgot_password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"forgot_password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/forgot_password/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"forgot_password"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /workflows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_workflow_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/new(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const new_workflow_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[6,"new"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /notion/unfurl(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notion_unfurl_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notion"],[2,[7,"/"],[2,[6,"unfurl"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /notion/unfurl(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const notion_unfurl_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"notion"],[2,[7,"/"],[2,[6,"unfurl"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_application_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/authorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorized_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorized_application_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/authorized_applications/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorized_application_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/authorized_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorized_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/authorized_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_authorized_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth_completions/stripe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_completions_stripe_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth_completions"],[2,[7,"/"],[2,[6,"stripe"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth_completions/stripe(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_completions_stripe_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth_completions"],[2,[7,"/"],[2,[6,"stripe"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/device(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_device_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/device(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_device_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/device(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_device_authorization_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/device(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_device_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/device/code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_device_code_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/device/code(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_device_code_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"device"],[2,[7,"/"],[2,[6,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_introspect_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/introspect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_introspect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"introspect"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_login_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/login(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_login_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"login"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /integrations/discord/oauth_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_redirect_integrations_discord_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"discord"],[2,[7,"/"],[2,[6,"oauth_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/discord/oauth_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_redirect_integrations_discord_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"discord"],[2,[7,"/"],[2,[6,"oauth_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/google_calendar/oauth_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_redirect_integrations_google_calendar_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google_calendar"],[2,[7,"/"],[2,[6,"oauth_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/google_calendar/oauth_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_redirect_integrations_google_calendar_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"google_calendar"],[2,[7,"/"],[2,[6,"oauth_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/zoom/oauth_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_redirect_integrations_zoom_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zoom"],[2,[7,"/"],[2,[6,"oauth_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/zoom/oauth_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_redirect_integrations_zoom_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"zoom"],[2,[7,"/"],[2,[6,"oauth_redirect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/revoke(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_revoke_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"revoke"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /oauth/token/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_info_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/token/info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const oauth_token_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"token"],[2,[7,"/"],[2,[6,"info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /offer_codes/compute_discount(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offer_codes_compute_discount_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_codes"],[2,[7,"/"],[2,[6,"compute_discount"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /offer_codes/compute_discount(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offer_codes_compute_discount_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_codes"],[2,[7,"/"],[2,[6,"compute_discount"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /offer_codes/selection_discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offer_codes_selection_discounts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_codes"],[2,[7,"/"],[2,[6,"selection_discounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /offer_codes/selection_discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const offer_codes_selection_discounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_codes"],[2,[7,"/"],[2,[6,"selection_discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /affiliates/onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_affiliates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /affiliates/onboarding(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const onboarding_affiliates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[6,"onboarding"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments/opt_in_to_au_backtax_collection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_in_to_au_backtax_collection_settings_payments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"opt_in_to_au_backtax_collection"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/opt_in_to_au_backtax_collection(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const opt_in_to_au_backtax_collection_settings_payments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"opt_in_to_au_backtax_collection"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/options(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const options_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/options(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const options_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /orders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /overlay(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overlay_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"overlay"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /overlay(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const overlay_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"overlay"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /pages/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /pages/:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /checkout/discounts/paged(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paged_checkout_discounts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[6,"paged"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/discounts/paged(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paged_checkout_discounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[6,"paged"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/upsells/paged(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paged_checkout_upsells_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[6,"paged"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/upsells/paged(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paged_checkout_upsells_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[6,"paged"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /pages(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pages_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pages"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/payouts/pause(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_api_internal_admin_payouts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/payouts/pause(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pause_api_internal_admin_payouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"pause"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /payouts/exportables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payouts_exportables_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"exportables"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /payouts/exportables(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payouts_exportables_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"exportables"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payouts/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payouts_exports_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /payouts/exports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const payouts_exports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"exports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /paypal_charge_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_charge_data_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal_charge_data"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /paypal_charge_data(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_charge_data_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal_charge_data"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/payments/paypal_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_connect_settings_payments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"paypal_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/paypal_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_connect_settings_payments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"paypal_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /paypal-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /paypal-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const paypal_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"paypal-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ping_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /ping(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const ping_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"ping"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/piracy_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const piracy_report_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/piracy_reports/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const piracy_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/piracy_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const piracy_reports_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/piracy_reports(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const piracy_reports_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /posts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const posts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"posts"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /orders/prepare(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepare_orders_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"prepare"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /orders/prepare(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prepare_orders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"orders"],[2,[7,"/"],[2,[6,"prepare"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/feature_announcement_campaigns/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_internal_admin_feature_announcement_campaign_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_announcement_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/feature_announcement_campaigns/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_internal_admin_feature_announcement_campaign_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"feature_announcement_campaigns"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/low_balance_probation_recoveries/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_internal_admin_low_balance_probation_recoveries_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"low_balance_probation_recoveries"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/low_balance_probation_recoveries/preview(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_internal_admin_low_balance_probation_recoveries_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"low_balance_probation_recoveries"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/emails/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_v2_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/emails/:id/preview(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_api_v2_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/products/:id/preview_custom_html(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_custom_html_api_v2_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_custom_html"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/products/:id/preview_custom_html(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_custom_html_api_v2_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"preview_custom_html"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /pages/:slug/preview(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_page_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pages/:slug/preview(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const preview_page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"preview"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:id/price_check(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const price_check_product_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"price_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:id/price_check(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const price_check_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"price_check"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pricing_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /pricing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const pricing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"pricing"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /privacy(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const privacy_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"privacy"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/available_offer_codes.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_available_offer_codes_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"available_offer_codes"],[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/available_offer_codes.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_available_offer_codes_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"available_offer_codes"],[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /products/:id/card(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_card_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:id/card(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_card_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /product_duplicates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_duplicate_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_duplicates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /product_duplicates/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_duplicate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_duplicates"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product_duplicates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_duplicates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_duplicates"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /product_duplicates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_duplicates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_duplicates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/marketing_abandoned_cart.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_marketing_abandoned_cart_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_abandoned_cart"],[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/marketing_abandoned_cart.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_marketing_abandoned_cart_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_abandoned_cart"],[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions/:id.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_marketing_action_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions/:id.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_marketing_action_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[7,"/"],[2,[3,"id"],[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_marketing_actions_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/marketing_actions.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_marketing_actions_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"marketing_actions"],[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/other_refund_policies.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_other_refund_policies_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"other_refund_policies"],[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/other_refund_policies.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_other_refund_policies_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"other_refund_policies"],[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /customers/product_purchases/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_purchases_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"product_purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /customers/product_purchases/:purchase_id(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_purchases_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"product_purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/product_purchases(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_purchases_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product_purchases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/product_purchases(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_purchases_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product_purchases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/remaining_call_availabilities.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_remaining_call_availabilities_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"remaining_call_availabilities"],[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/remaining_call_availabilities.:format
 * @param {any} product_id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_remaining_call_availabilities_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"remaining_call_availabilities"],[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /products/:product_id/remaining_call_availabilities/:id.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_remaining_call_availability_url = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"remaining_call_availabilities"],[2,[7,"/"],[2,[3,"id"],[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:product_id/remaining_call_availabilities/:id.:format
 * @param {any} product_id
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_remaining_call_availability_path = /*#__PURE__*/ __jsr.r({"product_id":{"r":true},"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"product_id"],[2,[7,"/"],[2,[6,"remaining_call_availabilities"],[2,[7,"/"],[2,[3,"id"],[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /product_reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /product_reviews/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_reviews"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product_review_responses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_response_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_review_responses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /product_review_responses/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_response_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_review_responses"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product_review_videos/:product_review_video_id/stream(.:format)
 * @param {any} product_review_video_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_video_stream_url = /*#__PURE__*/ __jsr.r({"product_review_video_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[3,"product_review_video_id"],[2,[7,"/"],[2,[6,"stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /product_review_videos/:product_review_video_id/stream(.:format)
 * @param {any} product_review_video_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_video_stream_path = /*#__PURE__*/ __jsr.r({"product_review_video_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[3,"product_review_video_id"],[2,[7,"/"],[2,[6,"stream"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /product_review_videos/:product_review_video_id/streaming_urls(.:format)
 * @param {any} product_review_video_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_video_streaming_urls_url = /*#__PURE__*/ __jsr.r({"product_review_video_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[3,"product_review_video_id"],[2,[7,"/"],[2,[6,"streaming_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /product_review_videos/:product_review_video_id/streaming_urls(.:format)
 * @param {any} product_review_video_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_video_streaming_urls_path = /*#__PURE__*/ __jsr.r({"product_review_video_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[3,"product_review_video_id"],[2,[7,"/"],[2,[6,"streaming_urls"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /product_review_videos/upload_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_videos_upload_context_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[6,"upload_context"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /product_review_videos/upload_context(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_review_videos_upload_context_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_review_videos"],[2,[7,"/"],[2,[6,"upload_context"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /product_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_reviews_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_reviews"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /product_reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_reviews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /product_reviews/set(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_reviews_set_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_reviews"],[2,[7,"/"],[2,[6,"set"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /product_reviews/set(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const product_reviews_set_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"product_reviews"],[2,[7,"/"],[2,[6,"set"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /products/affiliated/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_affiliated_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"affiliated"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/affiliated/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_affiliated_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"affiliated"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/affiliated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_affiliated_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"affiliated"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/affiliated(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_affiliated_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"affiliated"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mobile/analytics/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_api_mobile_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/analytics/products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_api_mobile_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/archived/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_archived_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"archived"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/archived/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_archived_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"archived"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/archived(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_archived_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/archived(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_archived_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"archived"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /products/collabs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_collabs_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"collabs"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/collabs(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_collabs_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"collabs"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /pages/:slug/products(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_page_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /pages/:slug/products(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"pages"],[2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /products/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_search_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /products/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const products_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_product_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /profile/products/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /profile_sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_section_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profile_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /profile_sections/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_section_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profile_sections"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /profile_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile_sections"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /profile_sections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_sections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"profile_sections"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /profile/:username(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_third_party_analytics_url = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /profile/:username(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profile_third_party_analytics_path = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"profile"],[2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profiles_settings_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profiles"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/profiles(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const profiles_settings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profiles"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /prohibited(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prohibited_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prohibited"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /prohibited(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const prohibited_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"prohibited"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /v2/products/:link_id/builds/:id/promote(.:format)
 * @param {any} link_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promote_api_v2_link_product_build_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"builds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/products/:link_id/builds/:id/promote(.:format)
 * @param {any} link_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const promote_api_v2_link_product_build_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"link_id"],[2,[7,"/"],[2,[6,"builds"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"promote"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id/publish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const publish_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"publish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/published(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const published_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"published"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /emails/published(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const published_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"published"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /purchase_custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_custom_fields_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchase_custom_fields"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /purchase_custom_fields(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_custom_fields_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchase_custom_fields"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /purchases/:purchase_id/dispute_evidence(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_dispute_evidence_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"dispute_evidence"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:purchase_id/dispute_evidence(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_dispute_evidence_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"dispute_evidence"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:purchase_id/invoice(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_invoice_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:purchase_id/invoice(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_invoice_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"invoice"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:purchase_id/pings(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_pings_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"pings"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:purchase_id/pings(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_pings_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"pings"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:purchase_id/product(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_product_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"product"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:purchase_id/product(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_product_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"product"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:purchase_id/variants/:variant_id(.:format)
 * @param {any} purchase_id
 * @param {any} variant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_variant_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"variant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"variant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:purchase_id/variants/:variant_id(.:format)
 * @param {any} purchase_id
 * @param {any} variant_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchase_variant_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"variant_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"variants"],[2,[7,"/"],[2,[3,"variant_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchases_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchases_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/purchases(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchases_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"purchases"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchases_search_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const purchases_search_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/radar_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const radar_stats_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"radar_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/radar_stats(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const radar_stats_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"radar_stats"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_url = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/redirect/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_url = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/representations/proxy/:signed_blob_id/:variation_key/*filename(.:format)
 * @param {any} signed_blob_id
 * @param {any} variation_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_blob_representation_proxy_path = /*#__PURE__*/ __jsr.r({"signed_blob_id":{"r":true},"variation_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"representations"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_blob_id"],[2,[7,"/"],[2,[3,"variation_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_url = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/incinerate(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_incinerate_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"incinerate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_url = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/:inbound_email_id/reroute(.:format)
 * @param {any} inbound_email_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_reroute_path = /*#__PURE__*/ __jsr.r({"inbound_email_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[3,"inbound_email_id"],[2,[7,"/"],[2,[6,"reroute"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails/sources(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_email_sources_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"sources"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/conductor/action_mailbox/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_conductor_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"conductor"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/direct_uploads(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_direct_uploads_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"direct_uploads"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_url = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_key/*filename(.:format)
 * @param {any} encoded_key
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_key":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_key"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mailgun/inbound_emails/mime(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mailgun_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mailgun"],[2,[7,"/"],[2,[6,"inbound_emails"],[2,[7,"/"],[2,[6,"mime"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/mandrill/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_mandrill_inbound_health_check_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"mandrill"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/postmark/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_postmark_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"postmark"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/relay/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_relay_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"relay"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/action_mailbox/sendgrid/inbound_emails(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_sendgrid_inbound_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"action_mailbox"],[2,[7,"/"],[2,[6,"sendgrid"],[2,[7,"/"],[2,[6,"inbound_emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_url = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/redirect/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"redirect"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_url = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/blobs/proxy/:signed_id/*filename(.:format)
 * @param {any} signed_id
 * @param {any} filename
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rails_service_blob_proxy_path = /*#__PURE__*/ __jsr.r({"signed_id":{"r":true},"filename":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"blobs"],[2,[7,"/"],[2,[6,"proxy"],[2,[7,"/"],[2,[3,"signed_id"],[2,[7,"/"],[2,[5,[3,"filename"]],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const read_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"read"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /read(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const read_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"read"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/reassign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reassign_api_internal_admin_purchases_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"reassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/reassign(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reassign_api_internal_admin_purchases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"reassign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipt_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const receipt_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /recommended_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recommended_products_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recommended_products"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /recommended_products(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recommended_products_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"recommended_products"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/stranded_buyers/recover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_api_internal_admin_stranded_buyers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stranded_buyers"],[2,[7,"/"],[2,[6,"recover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/stranded_buyers/recover(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const recover_api_internal_admin_stranded_buyers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stranded_buyers"],[2,[7,"/"],[2,[6,"recover"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /library/purchase/:purchase_id/update/:id(.:format)
 * @param {any} purchase_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirect_from_purchase_id_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /library/purchase/:purchase_id/update/:id(.:format)
 * @param {any} purchase_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const redirect_from_purchase_id_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"library"],[2,[7,"/"],[2,[6,"purchase"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"update"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/refund_all_for_fraud(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_all_for_fraud_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"refund_all_for_fraud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/refund_all_for_fraud(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_all_for_fraud_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"refund_all_for_fraud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_api_internal_admin_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_api_internal_admin_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/sales/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_api_v2_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/sales/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_api_v2_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/refund_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_balance_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"refund_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/refund_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_balance_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"refund_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/refund_for_fraud(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_for_fraud_api_internal_admin_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund_for_fraud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/refund_for_fraud(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_for_fraud_api_internal_admin_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund_for_fraud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/refund(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/refund_taxes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_taxes_api_internal_admin_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund_taxes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/refund_taxes(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const refund_taxes_api_internal_admin_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"refund_taxes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/totp/regenerate_recovery_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_recovery_codes_settings_totp_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"regenerate_recovery_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/totp/regenerate_recovery_codes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const regenerate_recovery_codes_settings_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"totp"],[2,[7,"/"],[2,[6,"regenerate_recovery_codes"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/passkeys/registration_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registration_options_settings_passkeys_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[6,"registration_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/passkeys/registration_options(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const registration_options_settings_passkeys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[6,"registration_options"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/review_videos/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_api_mobile_review_video_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"review_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/review_videos/:id/reject(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reject_api_mobile_review_video_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"review_videos"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"reject"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/related(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"related"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/related(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const related_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"related"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /products/:id/release_preorder(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const release_preorder_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"release_preorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /products/:id/release_preorder(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const release_preorder_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"release_preorder"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/products/:id/release_sales_hold(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const release_sales_hold_api_internal_admin_product_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"release_sales_hold"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/products/:id/release_sales_hold(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const release_sales_hold_api_internal_admin_product_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"release_sales_hold"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments/remediation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remediation_settings_payments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"remediation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/remediation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remediation_settings_payments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"remediation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments/remove_credit_card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_credit_card_settings_payments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"remove_credit_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/remove_credit_card(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_credit_card_settings_payments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"remove_credit_card"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/sendgrid_emails/remove_suppression(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_suppression_api_internal_admin_sendgrid_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sendgrid_emails"],[2,[7,"/"],[2,[6,"remove_suppression"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/sendgrid_emails/remove_suppression(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const remove_suppression_api_internal_admin_sendgrid_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"sendgrid_emails"],[2,[7,"/"],[2,[6,"remove_suppression"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/resend_all_receipts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_all_receipts_api_internal_admin_purchases_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"resend_all_receipts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/resend_all_receipts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_all_receipts_api_internal_admin_purchases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"resend_all_receipts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /two-factor/resend_authentication_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_authentication_token_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"resend_authentication_token"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /two-factor/resend_authentication_token(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_authentication_token_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"resend_authentication_token"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sessions/resend_confirmation_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_confirmation_email_api_mobile_sessions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"resend_confirmation_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sessions/resend_confirmation_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_confirmation_email_api_mobile_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sessions"],[2,[7,"/"],[2,[6,"resend_confirmation_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/resend_confirmation_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_confirmation_email_settings_main_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"resend_confirmation_email"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/resend_confirmation_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_confirmation_email_settings_main_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"resend_confirmation_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/team/invitations/:id/resend_invitation.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_invitation_settings_team_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invitation"],[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team/invitations/:id/resend_invitation.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_invitation_settings_team_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_invitation"],[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/resend_ping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_ping_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_ping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/resend_ping(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_ping_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_ping"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/resend_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_receipt_api_internal_admin_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/resend_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_receipt_api_internal_admin_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/resend_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_receipt_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/resend_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_receipt_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/sales/:id/resend_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_receipt_api_v2_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/sales/:id/resend_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_receipt_api_v2_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/resend_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_receipt_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/resend_receipt(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_receipt_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resend_receipt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /resend-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resend-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /resend-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resend_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"resend-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_password_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/reset_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reset_password_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"reset_password"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/piracy_reports/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_api_internal_admin_piracy_report_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/piracy_reports/:id/resolve(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resolve_api_internal_admin_piracy_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"resolve"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/restore_bank_payout_rail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_bank_payout_rail_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"restore_bank_payout_rail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/restore_bank_payout_rail(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_bank_payout_rail_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"restore_bank_payout_rail"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/team/invitations/:id/restore.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_settings_team_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team/invitations/:id/restore.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_settings_team_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/team/members/:id/restore.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_settings_team_member_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[2,[8,"."],[3,"format"]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team/members/:id/restore.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const restore_settings_team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"restore"],[2,[8,"."],[3,"format"]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/payouts/resume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resume_api_internal_admin_payouts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/payouts/resume(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const resume_api_internal_admin_payouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"resume"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/analytics/revenue_totals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revenue_totals_api_mobile_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"revenue_totals"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/analytics/revenue_totals(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revenue_totals_api_mobile_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"analytics"],[2,[7,"/"],[2,[6,"revenue_totals"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/review_response(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_response_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review_response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/review_response(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const review_response_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"review_response"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviews_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /reviews(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const reviews_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"reviews"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_access_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_access_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/sales/:id/revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_access_api_v2_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/sales/:id/revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_access_api_v2_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_access_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_access_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/url_redirects/:id/revoke_download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_download_api_internal_admin_url_redirect_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"url_redirects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/url_redirects/:id/revoke_download(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const revoke_download_api_internal_admin_url_redirect_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"url_redirects"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"revoke_download"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_url = /*#__PURE__*/ __jsr.r({}, [7,"/"], true);

/**
 * Generates rails route to
 * /
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const root_path = /*#__PURE__*/ __jsr.r({}, [7,"/"]);

/**
 * Generates rails route to
 * /v2/licenses/rotate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rotate_api_v2_licenses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/licenses/rotate(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const rotate_api_v2_licenses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"rotate"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /s3_utility/cdn_url_for_blob(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s3_utility_cdn_url_for_blob_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s3_utility"],[2,[7,"/"],[2,[6,"cdn_url_for_blob"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s3_utility/cdn_url_for_blob(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s3_utility_cdn_url_for_blob_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s3_utility"],[2,[7,"/"],[2,[6,"cdn_url_for_blob"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s3_utility/current_utc_time_string(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s3_utility_current_utc_time_string_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s3_utility"],[2,[7,"/"],[2,[6,"current_utc_time_string"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s3_utility/current_utc_time_string(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s3_utility_current_utc_time_string_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s3_utility"],[2,[7,"/"],[2,[6,"current_utc_time_string"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s3_utility/generate_multipart_signature(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s3_utility_generate_multipart_signature_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s3_utility"],[2,[7,"/"],[2,[6,"generate_multipart_signature"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s3_utility/generate_multipart_signature(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const s3_utility_generate_multipart_signature_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"s3_utility"],[2,[7,"/"],[2,[6,"generate_multipart_signature"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /saas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saas_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saas"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /saas(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const saas_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"saas"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /dashboard/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_dashboard_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_dashboard_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /customers/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_paged_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /customers/sales(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sales_paged_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"customers"],[2,[7,"/"],[2,[6,"sales"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /links/:id/send_sample_price_change_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sample_membership_price_change_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_sample_price_change_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id/send_sample_price_change_email(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sample_membership_price_change_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_sample_price_change_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /save_to_library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_to_library_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"save_to_library"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /save_to_library(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const save_to_library_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"save_to_library"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/stranded_buyers/scan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scan_api_internal_admin_stranded_buyers_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stranded_buyers"],[2,[7,"/"],[2,[6,"scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/stranded_buyers/scan(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scan_api_internal_admin_stranded_buyers_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"stranded_buyers"],[2,[7,"/"],[2,[6,"scan"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/emails/:id/schedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_api_v2_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/emails/:id/schedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const schedule_api_v2_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"schedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /emails/scheduled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduled_emails_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"scheduled"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /emails/scheduled(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const scheduled_emails_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[6,"scheduled"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/piracy_reports/:id/screen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screen_api_internal_admin_piracy_report_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"screen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/piracy_reports/:id/screen(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const screen_api_internal_admin_piracy_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"screen"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_api_internal_admin_purchases_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/search(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const search_api_internal_admin_purchases_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[6,"search"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:id/sections(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sections_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id/sections(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sections_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /secure_url_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secure_url_redirect_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_url_redirect"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /secure_url_redirect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const secure_url_redirect_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"secure_url_redirect"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /offer_codes/selection_discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selection_discounts_offer_codes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_codes"],[2,[7,"/"],[2,[6,"selection_discounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /offer_codes/selection_discounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const selection_discounts_offer_codes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"offer_codes"],[2,[7,"/"],[2,[6,"selection_discounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sellers/brand_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sellers_brand_accounts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"brand_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sellers/brand_accounts(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sellers_brand_accounts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"brand_accounts"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /sellers/switch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sellers_switch_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /sellers/switch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sellers_switch_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sellers"],[2,[7,"/"],[2,[6,"switch"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /v2/emails/:id/send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_api_v2_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/emails/:id/send(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_api_v2_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /posts/:id/send_for_purchase/:purchase_id(.:format)
 * @param {any} id
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_for_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_for_purchase"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /posts/:id/send_for_purchase/:purchase_id(.:format)
 * @param {any} id
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_for_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"posts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_for_purchase"],[2,[7,"/"],[2,[3,"purchase_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/send_post(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_post_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/send_post(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_post_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_post"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/send_to_kindle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_to_kindle_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_kindle"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/send_to_kindle(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const send_to_kindle_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"send_to_kindle"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /sendgrid-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendgrid_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sendgrid-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sendgrid-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sendgrid_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sendgrid-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /integrations/discord/server_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const server_info_integrations_discord_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"discord"],[2,[7,"/"],[2,[6,"server_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/discord/server_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const server_info_integrations_discord_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"discord"],[2,[7,"/"],[2,[6,"server_info"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments/set_country(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_country_settings_payments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"set_country"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/set_country(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const set_country_settings_payments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"set_country"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/advanced(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_advanced_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"advanced"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/advanced(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_advanced_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"advanced"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/applications/:application_id/access_tokens(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_application_access_tokens_url = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"access_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/applications/:application_id/access_tokens(.:format)
 * @param {any} application_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_application_access_tokens_path = /*#__PURE__*/ __jsr.r({"application_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"applications"],[2,[7,"/"],[2,[3,"application_id"],[2,[7,"/"],[2,[6,"access_tokens"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/authorized_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_authorized_applications_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/authorized_applications(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_authorized_applications_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"authorized_applications"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/beneficial_owners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_beneficial_owner_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"beneficial_owners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/beneficial_owners/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_beneficial_owner_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"beneficial_owners"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/beneficial_owners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_beneficial_owners_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"beneficial_owners"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/beneficial_owners(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_beneficial_owners_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"beneficial_owners"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_billing_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/billing(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_billing_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"billing"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/dismiss_ai_product_generation_promo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_dismiss_ai_product_generation_promo_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"dismiss_ai_product_generation_promo"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/dismiss_ai_product_generation_promo(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_dismiss_ai_product_generation_promo_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"dismiss_ai_product_generation_promo"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/guardians/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_guardian_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"guardians"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/guardians/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_guardian_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"guardians"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/guardians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_guardians_url = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"guardians"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/guardians(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_guardians_path = /*#__PURE__*/ __jsr.r({"format":{"d":"json"}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"guardians"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_main_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /settings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_main_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /settings/passkeys/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_passkey_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/passkeys/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_passkey_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"passkeys"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/passkeys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_passkeys_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"passkeys"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/passkeys(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_passkeys_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"passkeys"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_payments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_payments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_profile_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/profile(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_profile_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"profile"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/social_connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_social_connections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"social_connections"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/social_connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_social_connections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"social_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/team/invitations/:id.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_invitation_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team/invitations/:id.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_invitation_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[7,"/"],[2,[3,"id"],[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/team/invitations.:format
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_invitations_url = /*#__PURE__*/ __jsr.r({"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team/invitations.:format
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_invitations_path = /*#__PURE__*/ __jsr.r({"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"invitations"],[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /settings/team/members/:id.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_member_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[8,"."],[3,"format"]]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team/members/:id.:format
 * @param {any} id
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_member_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[7,"/"],[2,[3,"id"],[2,[8,"."],[3,"format"]]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/team/members.:format
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_members_url = /*#__PURE__*/ __jsr.r({"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[8,"."],[3,"format"]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/team/members.:format
 * @param {any} format
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_team_members_path = /*#__PURE__*/ __jsr.r({"format":{"r":true}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"team"],[2,[7,"/"],[2,[6,"members"],[2,[8,"."],[3,"format"]]]]]]]]);

/**
 * Generates rails route to
 * /settings/third_party_analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_third_party_analytics_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"third_party_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/third_party_analytics(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_third_party_analytics_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"third_party_analytics"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /settings/totp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_totp_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"totp"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /settings/totp(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const settings_totp_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"totp"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /l/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /l/:id/landing/embed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_link_landing_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /l/:id/landing/embed(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_link_landing_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /l/:id/landing/version(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_link_landing_version_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /l/:id/landing/version(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_link_landing_version_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /l/:id/:code(.:format)
 * @param {any} id
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_link_offer_code_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"code":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /l/:id/:code(.:format)
 * @param {any} id
 * @param {any} code
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const short_link_offer_code_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"code":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[6,"l"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"code"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /dashboard/piracy_reports/:id/sign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_piracy_report_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /dashboard/piracy_reports/:id/sign(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sign_piracy_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"dashboard"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"sign"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signup_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /signup(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const signup_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"signup"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /small-bets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const small_bets_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"small-bets"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /small-bets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const small_bets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"small-bets"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sns-aws-config-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sns_aws_config_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sns-aws-config-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sns-aws-config-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sns_aws_config_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sns-aws-config-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sns-mediaconvert-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sns_mediaconvert_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sns-mediaconvert-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sns-mediaconvert-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sns_mediaconvert_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sns-mediaconvert-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /sns-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sns_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sns-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /sns-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const sns_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"sns-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/social_connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const social_connections_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"social_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/social_connections(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const social_connections_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"social_connections"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /integrations/circle/space_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const space_groups_integrations_circle_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"circle"],[2,[7,"/"],[2,[6,"space_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /integrations/circle/space_groups(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const space_groups_integrations_circle_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"integrations"],[2,[7,"/"],[2,[6,"circle"],[2,[7,"/"],[2,[6,"space_groups"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/piracy_reports/:id/start_screening(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_screening_api_internal_admin_piracy_report_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start_screening"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/piracy_reports/:id/start_screening(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const start_screening_api_internal_admin_piracy_report_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"piracy_reports"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"start_screening"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /affiliates/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_affiliate_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /affiliates/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_affiliate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/discounts/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_checkout_discount_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/discounts/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_checkout_discount_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"discounts"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /checkout/upsells/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_checkout_upsell_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /checkout/upsells/:id/statistics(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const statistics_checkout_upsell_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"checkout"],[2,[7,"/"],[2,[6,"upsells"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"statistics"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /cart_items_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storefront_cart_items_count_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cart_items_count"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /cart_items_count(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const storefront_cart_items_count_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"cart_items_count"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /stripe-connect-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_connect_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe-connect-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /stripe-connect-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_connect_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe-connect-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /stripe/setup_intents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_setup_intents_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"setup_intents"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /stripe/setup_intents(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_setup_intents_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe"],[2,[7,"/"],[2,[6,"setup_intents"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /stripe-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /stripe-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const stripe_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"stripe-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /affiliates/:id/subscribe_posts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_posts_affiliate_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribe_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /affiliates/:id/subscribe_posts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_posts_affiliate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribe_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/subscribe(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/subscribe(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscribe_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"subscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /subscriptions/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/:subscription_id/magic_link(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_magic_link_url = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"magic_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /subscriptions/:subscription_id/magic_link(.:format)
 * @param {any} subscription_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const subscription_magic_link_path = /*#__PURE__*/ __jsr.r({"subscription_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"subscription_id"],[2,[7,"/"],[2,[6,"magic_link"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:purchase_id/dispute_evidence/success(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_purchase_dispute_evidence_url = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"dispute_evidence"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:purchase_id/dispute_evidence/success(.:format)
 * @param {any} purchase_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const success_purchase_dispute_evidence_path = /*#__PURE__*/ __jsr.r({"purchase_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"purchase_id"],[2,[7,"/"],[2,[6,"dispute_evidence"],[2,[7,"/"],[2,[6,"success"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/suspend_for_fraud(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suspend_for_fraud_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"suspend_for_fraud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/suspend_for_fraud(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suspend_for_fraud_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"suspend_for_fraud"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/suspend_for_tos_violation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suspend_for_tos_violation_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"suspend_for_tos_violation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/suspend_for_tos_violation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suspend_for_tos_violation_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"suspend_for_tos_violation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/suspension(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suspension_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"suspension"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/suspension(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const suspension_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"suspension"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /oauth/mobile_pre_authorization/switch_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_account_oauth_mobile_pre_authorization_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"mobile_pre_authorization"],[2,[7,"/"],[2,[6,"switch_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /oauth/mobile_pre_authorization/switch_account(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_account_oauth_mobile_pre_authorization_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"oauth"],[2,[7,"/"],[2,[6,"mobile_pre_authorization"],[2,[7,"/"],[2,[6,"switch_account"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /two-factor/switch_to_authenticator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_to_authenticator_two_factor_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"switch_to_authenticator"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /two-factor/switch_to_authenticator(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_to_authenticator_two_factor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"switch_to_authenticator"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /two-factor/switch_to_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_to_email_two_factor_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"switch_to_email"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /two-factor/switch_to_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_to_email_two_factor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"switch_to_email"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /two-factor/switch_to_recovery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_to_recovery_two_factor_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"switch_to_recovery"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /two-factor/switch_to_recovery(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const switch_to_recovery_two_factor_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"switch_to_recovery"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /tags(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tags_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tags"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /payouts/taxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tax_center_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"taxes"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /payouts/taxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tax_center_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"taxes"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /payouts/taxes/:year/transaction_report(.:format)
 * @param {any} year
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tax_form_transaction_report_url = /*#__PURE__*/ __jsr.r({"year":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"year"],[2,[7,"/"],[2,[6,"transaction_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /payouts/taxes/:year/transaction_report(.:format)
 * @param {any} year
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tax_form_transaction_report_path = /*#__PURE__*/ __jsr.r({"year":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"taxes"],[2,[7,"/"],[2,[3,"year"],[2,[7,"/"],[2,[6,"transaction_report"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /taxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxes_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxes"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /taxes(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const taxes_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"taxes"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /terms(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const terms_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"terms"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /test_pings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_pings_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"test_pings"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /test_pings(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const test_pings_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"test_pings"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:link_id(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const third_party_analytics_url = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"link_id"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /:link_id(.:format)
 * @param {any} link_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const third_party_analytics_path = /*#__PURE__*/ __jsr.r({"link_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"link_id"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /tiktok/deauthorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tiktok_deauthorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tiktok"],[2,[7,"/"],[2,[6,"deauthorize"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /tiktok/deauthorize(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const tiktok_deauthorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"tiktok"],[2,[7,"/"],[2,[6,"deauthorize"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /links/:id/track_user_action(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const track_user_action_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"track_user_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id/track_user_action(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const track_user_action_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"track_user_action"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /two-factor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const two_factor_authentication_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /two-factor(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const two_factor_authentication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/two_factor_authentication(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const two_factor_authentication_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"two_factor_authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/two_factor_authentication(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const two_factor_authentication_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"two_factor_authentication"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/unblock_buyer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unblock_buyer_api_internal_admin_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unblock_buyer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/purchases/:id/unblock_buyer(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unblock_buyer_api_internal_admin_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unblock_buyer"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/undo_revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undo_revoke_access_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/undo_revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undo_revoke_access_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/sales/:id/undo_revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undo_revoke_access_api_v2_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/sales/:id/undo_revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undo_revoke_access_api_v2_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/undo_revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undo_revoke_access_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/undo_revoke_access(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const undo_revoke_access_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"undo_revoke_access"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/connections/unlink_instagram(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_instagram_settings_connections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"unlink_instagram"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/connections/unlink_instagram(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_instagram_settings_connections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"unlink_instagram"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/connections/unlink_tiktok(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_tiktok_settings_connections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"unlink_tiktok"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/connections/unlink_tiktok(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_tiktok_settings_connections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"unlink_tiktok"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/connections/unlink_twitter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_twitter_settings_connections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"unlink_twitter"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/connections/unlink_twitter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_twitter_settings_connections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"unlink_twitter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/connections/unlink_youtube(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_youtube_settings_connections_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"unlink_youtube"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/connections/unlink_youtube(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unlink_youtube_settings_connections_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"connections"],[2,[7,"/"],[2,[6,"unlink_youtube"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/unpaid_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpaid_balance_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unpaid_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/unpaid_balance(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpaid_balance_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unpaid_balance"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /links/:id/unpublish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpublish_link_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpublish"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /links/:id/unpublish(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unpublish_link_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"links"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unpublish"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/emails/:id/unschedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unschedule_api_v2_email_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/emails/:id/unschedule(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unschedule_api_v2_email_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"emails"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unschedule"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/:id/unsubscribe_by_seller(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_by_seller_subscription_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe_by_seller"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /subscriptions/:id/unsubscribe_by_seller(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_by_seller_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe_by_seller"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /subscriptions/:id/unsubscribe_by_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_by_user_subscription_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe_by_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /subscriptions/:id/unsubscribe_by_user(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_by_user_subscription_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"subscriptions"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe_by_user"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /imported_customers/unsubscribe/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_imported_customer_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"imported_customers"],[2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /imported_customers/unsubscribe/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_imported_customer_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"imported_customers"],[2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /affiliates/:id/unsubscribe_posts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_posts_affiliate_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /affiliates/:id/unsubscribe_posts(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_posts_affiliate_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"affiliates"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe_posts"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /purchases/:id/unsubscribe(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_purchase_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /purchases/:id/unsubscribe(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_purchase_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"purchases"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /wishlists/:wishlist_id/followers/unsubscribe(.:format)
 * @param {any} wishlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_wishlist_followers_url = /*#__PURE__*/ __jsr.r({"wishlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"wishlist_id"],[2,[7,"/"],[2,[6,"followers"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /wishlists/:wishlist_id/followers/unsubscribe(.:format)
 * @param {any} wishlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unsubscribe_wishlist_followers_path = /*#__PURE__*/ __jsr.r({"wishlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"wishlist_id"],[2,[7,"/"],[2,[6,"followers"],[2,[7,"/"],[2,[6,"unsubscribe"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/unwatch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unwatch_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unwatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/unwatch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const unwatch_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unwatch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/payouts/upcoming(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upcoming_api_v2_payouts_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"upcoming"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/payouts/upcoming(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const upcoming_api_v2_payouts_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"payouts"],[2,[7,"/"],[2,[6,"upcoming"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/update_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_email_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/update_email(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_email_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_email"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /bundles/:bundle_id/content/update_purchases_content(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_purchases_content_bundle_content_url = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[6,"update_purchases_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /bundles/:bundle_id/content/update_purchases_content(.:format)
 * @param {any} bundle_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_purchases_content_bundle_content_path = /*#__PURE__*/ __jsr.r({"bundle_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"bundles"],[2,[7,"/"],[2,[3,"bundle_id"],[2,[7,"/"],[2,[6,"content"],[2,[7,"/"],[2,[6,"update_purchases_content"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_url = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /rails/active_storage/disk/:encoded_token(.:format)
 * @param {any} encoded_token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_rails_disk_service_path = /*#__PURE__*/ __jsr.r({"encoded_token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"rails"],[2,[7,"/"],[2,[6,"active_storage"],[2,[7,"/"],[2,[6,"disk"],[2,[7,"/"],[2,[3,"encoded_token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/update_watch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_watch_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_watch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/update_watch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const update_watch_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"update_watch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /updates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /updates(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const updates_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"updates"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /r/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/change_purchaser(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_change_purchaser_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_purchaser"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/change_purchaser(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_change_purchaser_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"change_purchaser"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/check_purchaser(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_check_purchaser_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_purchaser"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/check_purchaser(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_check_purchaser_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"check_purchaser"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /zip/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_download_archive_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /zip/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_download_archive_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"zip"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /d/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_download_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /d/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_download_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"d"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/product_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_download_product_files_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/product_files(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_download_product_files_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"product_files"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/:subtitle_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {any} subtitle_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_download_subtitle_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"subtitle_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[3,"subtitle_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/:subtitle_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {any} subtitle_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_download_subtitle_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"subtitle_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[3,"subtitle_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/expired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_expired_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"expired"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/expired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_expired_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"expired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /media_urls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_media_urls_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_urls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /media_urls/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_media_urls_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"media_urls"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/membership_inactive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_membership_inactive_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"membership_inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/membership_inactive(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_membership_inactive_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"membership_inactive"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /read/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_read_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"read"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /read/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_read_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"read"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /read/:id/:product_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_read_for_product_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"read"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /read/:id/:product_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_read_for_product_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"read"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/rental_expired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_rental_expired_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rental_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/rental_expired(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_rental_expired_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"rental_expired"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/save_last_content_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_save_last_content_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_last_content_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/save_last_content_page(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_save_last_content_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"save_last_content_page"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/stream.smil(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_smil_for_product_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[6,"stream"],[2,[8,"."],[2,[6,"smil"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/stream.smil(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_smil_for_product_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[6,"stream"],[2,[8,"."],[2,[6,"smil"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /s/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_stream_page_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_stream_page_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /s/:id/:product_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_stream_page_for_product_file_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /s/:id/:product_file_id(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_stream_page_for_product_file_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"s"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/:subtitle_file_id/captions.vtt(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {any} subtitle_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_subtitle_file_vtt_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"subtitle_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[3,"subtitle_file_id"],[2,[7,"/"],[2,[6,"captions"],[2,[8,"."],[2,[6,"vtt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /r/:id/:product_file_id/:subtitle_file_id/captions.vtt(.:format)
 * @param {any} id
 * @param {any} product_file_id
 * @param {any} subtitle_file_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const url_redirect_subtitle_file_vtt_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"product_file_id":{"r":true},"subtitle_file_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"r"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[3,"product_file_id"],[2,[7,"/"],[2,[3,"subtitle_file_id"],[2,[7,"/"],[2,[6,"captions"],[2,[8,"."],[2,[6,"vtt"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_url = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /:username(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_path = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{"d":"html"}}, [2,[7,"/"],[2,[3,"username"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/auth/apple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_apple_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"apple"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/apple(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_apple_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"apple"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/apple/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_apple_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"apple"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/apple/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_apple_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"apple"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/confirmation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_confirmation_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"confirmation"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/google_oauth2(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/google_oauth2/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_google_oauth2_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"google_oauth2"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/instagram(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_instagram_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"instagram"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/instagram(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_instagram_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"instagram"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/instagram/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_instagram_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/instagram/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_instagram_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"instagram"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /user/invalidate_active_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invalidate_active_sessions_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"invalidate_active_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /user/invalidate_active_sessions(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_invalidate_active_sessions_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"user"],[2,[7,"/"],[2,[6,"invalidate_active_sessions"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/landing/embed(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_landing_url = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:username/landing/embed(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_landing_path = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/landing/products
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_landing_products_url = /*#__PURE__*/ __jsr.r({"username":{"r":true}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[6,"products"]]]]]], true);

/**
 * Generates rails route to
 * /:username/landing/products
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_landing_products_path = /*#__PURE__*/ __jsr.r({"username":{"r":true}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[6,"products"]]]]]]);

/**
 * Generates rails route to
 * /:username/landing/version(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_landing_version_url = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:username/landing/version(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_landing_version_path = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_page_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /:slug(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_page_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /:slug/landing/embed(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_page_landing_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:slug/landing/embed(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_page_landing_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"embed"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /:slug/landing/version(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_page_landing_version_url = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:slug/landing/version(.:format)
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_page_landing_version_path = /*#__PURE__*/ __jsr.r({"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"slug"],[2,[7,"/"],[2,[6,"landing"],[2,[7,"/"],[2,[6,"version"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/forgot_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"forgot_password"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/forgot_password(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_password_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"forgot_password"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /users(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_registration_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/session_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_info_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"session_info"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/session_info(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_session_info_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"session_info"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/stripe_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_stripe_connect_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"stripe_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/stripe_connect(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_stripe_connect_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"stripe_connect"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/stripe_connect/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_stripe_connect_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/stripe_connect/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_stripe_connect_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"stripe_connect"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /:username/subscribe_preview(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_subscribe_preview_url = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"subscribe_preview"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /:username/subscribe_preview(.:format)
 * @param {any} username
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_subscribe_preview_path = /*#__PURE__*/ __jsr.r({"username":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"subscribe_preview"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/subscribe_review_reminders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_subscribe_review_reminders_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"subscribe_review_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/subscribe_review_reminders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_subscribe_review_reminders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"subscribe_review_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/subscribe_review_reminders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_subscribe_review_reminders_by_token_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"subscribe_review_reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/subscribe_review_reminders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_subscribe_review_reminders_by_token_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"subscribe_review_reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/tiktok(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_tiktok_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"tiktok"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/tiktok(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_tiktok_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"tiktok"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/tiktok/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_tiktok_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"tiktok"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/tiktok/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_tiktok_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"tiktok"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/twitter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_twitter_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"twitter"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/twitter(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_twitter_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"twitter"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/twitter/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_twitter_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"twitter"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/twitter/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_twitter_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"twitter"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/unsubscribe/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe_feature_announcements/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_feature_announcements_url = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_feature_announcements"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/unsubscribe_feature_announcements/:token(.:format)
 * @param {any} token
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_feature_announcements_path = /*#__PURE__*/ __jsr.r({"token":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_feature_announcements"],[2,[7,"/"],[2,[3,"token"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe_review_reminders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_review_reminders_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_review_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/unsubscribe_review_reminders(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_review_reminders_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_review_reminders"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/unsubscribe_review_reminders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_review_reminders_by_token_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_review_reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/unsubscribe_review_reminders/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_unsubscribe_review_reminders_by_token_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"unsubscribe_review_reminders"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/youtube(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_youtube_omniauth_authorize_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"youtube"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/youtube(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_youtube_omniauth_authorize_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"youtube"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/youtube/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_youtube_omniauth_callback_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"youtube"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/youtube/callback(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const user_youtube_omniauth_callback_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"youtube"],[2,[7,"/"],[2,[6,"callback"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /users/auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_auth_failure_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /users/auth/failure(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_auth_failure_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"auth"],[2,[7,"/"],[2,[6,"failure"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_in_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_in(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_in_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_in"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /users/sign_up(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const users_sign_up_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"sign_up"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /utm_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const utm_links_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"utm_links"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /utm_links(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const utm_links_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"utm_links"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /mobile/sales/:id/variant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const variant_api_mobile_sale_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"variant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /mobile/sales/:id/variant(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const variant_api_mobile_sale_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"mobile"],[2,[7,"/"],[2,[6,"sales"],[2,[7,"/"],[2,[3,"id"],[2,[7,"/"],[2,[6,"variant"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /v2/licenses/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_api_v2_licenses_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /v2/licenses/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_api_v2_licenses_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"v2"],[2,[7,"/"],[2,[6,"licenses"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /settings/payments/verify_stripe_remediation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_stripe_remediation_settings_payments_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"verify_stripe_remediation"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /settings/payments/verify_stripe_remediation(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_stripe_remediation_settings_payments_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"settings"],[2,[7,"/"],[2,[6,"payments"],[2,[7,"/"],[2,[6,"verify_stripe_remediation"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /two-factor/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_two_factor_authentication_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /two-factor/verify(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const verify_two_factor_authentication_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"two-factor"],[2,[7,"/"],[2,[6,"verify"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /:username/p/:slug(.:format)
 * @param {any} username
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_post_url = /*#__PURE__*/ __jsr.r({"username":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /:username/p/:slug(.:format)
 * @param {any} username
 * @param {any} slug
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const view_post_path = /*#__PURE__*/ __jsr.r({"username":{"r":true},"slug":{"r":true},"format":{}}, [2,[7,"/"],[2,[3,"username"],[2,[7,"/"],[2,[6,"p"],[2,[7,"/"],[2,[3,"slug"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /internal/admin/users/watch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const watch_api_internal_admin_users_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"watch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /internal/admin/users/watch(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const watch_api_internal_admin_users_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"internal"],[2,[7,"/"],[2,[6,"admin"],[2,[7,"/"],[2,[6,"users"],[2,[7,"/"],[2,[6,"watch"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /webhooks(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const webhooks_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"webhooks"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /widgets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widgets_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"widgets"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /widgets(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const widgets_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"widgets"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wishlists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlist_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /wishlists/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlist_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /wishlists/:wishlist_id/followers(.:format)
 * @param {any} wishlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlist_followers_url = /*#__PURE__*/ __jsr.r({"wishlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"wishlist_id"],[2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /wishlists/:wishlist_id/followers(.:format)
 * @param {any} wishlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlist_followers_path = /*#__PURE__*/ __jsr.r({"wishlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"wishlist_id"],[2,[7,"/"],[2,[6,"followers"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /wishlists/:wishlist_id/products/:id(.:format)
 * @param {any} wishlist_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlist_product_url = /*#__PURE__*/ __jsr.r({"wishlist_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"wishlist_id"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]], true);

/**
 * Generates rails route to
 * /wishlists/:wishlist_id/products/:id(.:format)
 * @param {any} wishlist_id
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlist_product_path = /*#__PURE__*/ __jsr.r({"wishlist_id":{"r":true},"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"wishlist_id"],[2,[7,"/"],[2,[6,"products"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]]]]]);

/**
 * Generates rails route to
 * /wishlists/:wishlist_id/products(.:format)
 * @param {any} wishlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlist_products_url = /*#__PURE__*/ __jsr.r({"wishlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"wishlist_id"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /wishlists/:wishlist_id/products(.:format)
 * @param {any} wishlist_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlist_products_path = /*#__PURE__*/ __jsr.r({"wishlist_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[3,"wishlist_id"],[2,[7,"/"],[2,[6,"products"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /wishlists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlists_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /wishlists(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlists_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /wishlists/following(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlists_following_index_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /wishlists/following(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const wishlists_following_index_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"wishlists"],[2,[7,"/"],[2,[6,"following"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /workflows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflow_url = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/:id(.:format)
 * @param {any} id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflow_path = /*#__PURE__*/ __jsr.r({"id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"id"],[1,[2,[8,"."],[3,"format"]]]]]]]);

/**
 * Generates rails route to
 * /workflows/:workflow_id/emails(.:format)
 * @param {any} workflow_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflow_emails_url = /*#__PURE__*/ __jsr.r({"workflow_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]], true);

/**
 * Generates rails route to
 * /workflows/:workflow_id/emails(.:format)
 * @param {any} workflow_id
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflow_emails_path = /*#__PURE__*/ __jsr.r({"workflow_id":{"r":true},"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[2,[7,"/"],[2,[3,"workflow_id"],[2,[7,"/"],[2,[6,"emails"],[1,[2,[8,"."],[3,"format"]]]]]]]]]);

/**
 * Generates rails route to
 * /workflows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflows_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /workflows(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const workflows_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"workflows"],[1,[2,[8,"."],[3,"format"]]]]]);

/**
 * Generates rails route to
 * /working-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const working_webhook_url = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"working-webhook"],[1,[2,[8,"."],[3,"format"]]]]], true);

/**
 * Generates rails route to
 * /working-webhook(.:format)
 * @param {object | undefined} options
 * @returns {string} route path
 */
export const working_webhook_path = /*#__PURE__*/ __jsr.r({"format":{}}, [2,[7,"/"],[2,[6,"working-webhook"],[1,[2,[8,"."],[3,"format"]]]]]);

